<template>
<div>
    <!-- Criar Modal -->
    <div class="modal fade" id="criarFaturaModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Criar Fatura</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="guias">
            <h2 class="text-primary">
              {{ guias.length }}
              {{ guias.length > 1 ? "guias selecionadas" : "guia selecionada" }}
            </h2>
            <p>{{ periodo }}</p>

            <h3 class="mt-2">Confirma a criação da fatura?</h3>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Cancelar
            </button>
            <az-submit @click="criar()">Criar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Criar Modal -->
    <div class="modal fade" id="faturaModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Fatura</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="fatura">
            <div class="row">
              <div class="col">
                <div class="display-4">
                  <a href="#" @click.prevent="$util.abrirFatura(fatura.id_fatura)" class="card-link">{{ fatura.id_fatura }}</a>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <small class="form-text text-muted text-nowrap text-truncate">Operadora</small>
                {{ fatura.operadora.search }}
              </div>
            </div>
            <div class="row">
              <div class="col">
                <small class="form-text text-muted text-nowrap text-truncate">Período</small>
                {{ $util.getFormatDate(fatura.dt_inicio) }} a
                {{ $util.getFormatDate(fatura.dt_fim) }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Fechar
            </button>
            <button type="button" class="btn btn-success" @click="$util.abrirFatura(fatura.id_fatura)">
              Abrir Fatura
            </button>
          </div>
        </div>
      </div>
    </div>

    <template v-if="exibir && !fatura && $store.state.loading">
      <az-empty-state />
    </template>

    <div v-if="fatura && exibir">
      <div class="card mt-3 mb-3 dashcard w3-animate-opacity">
        <div class="card-header">
          <div class="d-flex justify-content-between flex-column flex-md-row">
            <az-break-title
              :no_margin="true"
              :title=" ( fatura.fl_reapresentacao ? 'Recurso de Glosa' : 'Fatura' ) +  ': ' + fatura.id_fatura"
              :qtd="fatura.status"
              :badgecolor="fatura.status_color">
              <template v-slot:status>
                <span class="badge ml-2" :class="'badge-' + fatura.status_contato.contato_status.st_color" 
                    v-if="fatura.status_contato && fatura.status_contato.contato_status">
                    {{ fatura.status_contato.contato_status.search }}
                </span>
              </template>
            </az-break-title>
            <div class="d-flex align-items-md-end flex-column flex-md-row">

              <!-- Barra de progresso SIAD -->
              <siad-batch-progress :batch-id="fatura.st_siad_batch_id" />

              <div class="dropdown ml-1 mt-1"
                v-if="fatura.ch_status == 'FE' && integracao_siad && (fatura.operadora.st_registro_ans == '005711' || fatura.operadora.st_registro_ans == '421715' || fatura.operadora.st_registro_ans == '333689')">
                <button class="btn btn-outline-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" :disabled="$store.state.loading">
                  SIAD
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" href="#" @click.prevent="integrar_com_siad(fatura)">
                    <i class="fas fa-sync"></i>
                    Integrar Todas as Guias
                  </a>
                  <a class="dropdown-item" href="#" @click.prevent="integrar_com_siad(fatura, true)">
                    <i class="fas fa-sync"></i>
                    Integrar Guias Selecionadas
                  </a>
                  <a class="dropdown-item" href="#" v-if="fatura.log_integracaos_count" @click.prevent="abrir_log_int()" title="Logs de Integração">
                    <i class="fa-solid fa-comment-dots"></i>
                    Abrir Logs de Integração
                  </a>
                </div>
              </div>

              <button class="btn btn-outline-secondary btn-sm ml-1 mt-1" type="button" 
                @click.prevent="gerar_arquivo_fatura()"
                :disabled="$store.state.loading" v-if="(fatura.ch_status == 'FA' || fatura.ch_status == 'FE' || fatura.ch_status == 'FM') && !fatura.operadora.fl_sus">
                <i class="fas fa-file-export mr-1" v-if="!$store.state.loading"></i>
                <div class="spinner-border spinner-border-sm mr-1" role="status" v-else>
                  <span class="sr-only">Loading...</span>
                </div>
                {{ fatura.ch_status == "FA" ? "Arquivo para Envio" : "Gerar Arquivo" }} {{ integracao_ipe ? " (IPE)" : "" }}
              </button>


              <!-- Fatura a Enviar -->
              <!-- <button class="btn btn-outline-secondary btn-sm ml-1 mt-1 dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" -->
              <!--   :disabled="$store.state.loading" v-if="(fatura.ch_status == 'FA' || fatura.ch_status == 'FE') && !fatura.operadora.fl_sus"> -->
              <!--   <i class="fas fa-file-export mr-1" v-if="!$store.state.loading"></i> -->
              <!--   <div class="spinner-border spinner-border-sm mr-1" role="status" v-else> -->
              <!--     <span class="sr-only">Loading...</span> -->
              <!--   </div> -->
              <!--   {{ fatura.ch_status == "FA" ? "Arquivo para Envio" : "Gerar Arquivo" }} -->
              <!-- </button> -->
              <!-- <div class="dropdown-menu" aria-labelledby="dropdownMenuButton"> -->
              <!--   <a class="dropdown-item" href="#" @click.prevent="gerar_arquivo(null, null, null)" v-if="!fatura.fl_reapresentacao"> -->
              <!--     <i class="fas fa-file-archive text-success mr-2"></i>{{ fatura.ch_status == "FA" ? "ZIP - Arquivo para envio ordenado por nome do paciente" : "ZIP - Arquivo ordenado por nome do paciente" }} -->
              <!--   </a> -->
              <!--   <a class="dropdown-item" href="#" @click.prevent="gerar_arquivo(null, null, 'S')" v-if="!fatura.fl_reapresentacao"> -->
              <!--     <i class="fas fa-file-archive text-success mr-2"></i>{{ fatura.ch_status == "FA" ? "ZIP - Arquivo para envio ordenado por número da guia" : "ZIP - Arquivo ordenado por número da guia" }} -->
              <!--   </a> -->
              <!--   <a class="dropdown-item" href="#" @click.prevent="gerar_arquivo(null, null, null, 'S')" v-if="!fatura.fl_reapresentacao && (fatura && fatura.guia_faturas && fatura.guia_faturas.length <= 100) && podeGerarXml"> -->
              <!--     <i class="fas fa-file-export text-primary mr-2"></i>{{ fatura.ch_status == "FA" ? "XML - Arquivo para envio ordenado por nome do paciente" : "XML - rquivo ordenado por nome do paciente" }}l -->
              <!--   </a> -->
              <!--   <a class="dropdown-item" href="#" @click.prevent="gerar_arquivo(null, null, 'S', 'S')" v-if="!fatura.fl_reapresentacao && (fatura && fatura.guia_faturas && fatura.guia_faturas.length <= 100) && podeGerarXml"> -->
              <!--     <i class="fas fa-file-export text-primary mr-2"></i>{{ fatura.ch_status == "FA" ? "XML - Arquivo para envio ordenado por número da guia" : "XML - Arquivo ordenado por número da guia" }} -->
              <!--   </a> -->
              <!---->
              <!--   <a class="dropdown-item" href="#" @click.prevent="gerar_arquivo()" v-if="fatura.fl_reapresentacao"> -->
              <!--     <i class="fas fa-file-export mr-2" aria-hidden="true"></i>Refaturamento -->
              <!--   </a> -->
              <!--    <a class="dropdown-item" href="#" @click.prevent="gerar_arquivo(null, 'recurso')" v-if="fatura.fl_reapresentacao"> -->
              <!--     <i class="fas fa-file-export mr-2" aria-hidden="true"></i>Recurso de Glosa -->
              <!--   </a> -->
              <!-- </div> -->
              <!-- BPA -->
              <div class="dropdown ml-1 mt-1" v-if="fatura.ch_status == 'FA' && fatura.operadora.fl_sus && tem_bpa">
                <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :disabled="$store.state.loading">
                  <i class="fas fa-file-export mr-1" v-if="!$store.state.loading"></i>
                  <div class="spinner-border spinner-border-sm mr-1" role="status" v-else>
                    <span class="sr-only">Loading...</span>
                  </div>
                  BPA
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" href="#" @click.prevent="gerar_arquivo('B')">Arquivo</a>
                  <a class="dropdown-item" href="#" @click.prevent="gerar_arquivo('B', null, null, null, { tipo_saida: 'R' })">Relatório</a>
                </div>
              </div>

              <button class="btn btn-outline-secondary btn-sm ml-1 mt-1" type="button" :disabled="$store.state.loading"
                v-if="1==0 && fatura.ch_status == 'FA' && fatura.operadora.fl_sus && tem_bpa" @click="gerar_arquivo('B')">
                <i class="fas fa-file-export mr-1" v-if="!$store.state.loading"></i>
                <div class="spinner-border spinner-border-sm mr-1" role="status" v-else>
                  <span class="sr-only">Loading...</span>
                </div>
                BPA
              </button>
              <!-- APAC -->
              <button class="btn btn-outline-secondary btn-sm ml-1 mt-1" type="button" :disabled="$store.state.loading"
                v-if="fatura.ch_status == 'FA' && fatura.operadora.fl_sus && tem_apac" @click="gerar_arquivo('A')">
                <i class="fas fa-file-export mr-1" v-if="!$store.state.loading"></i>
                <div class="spinner-border spinner-border-sm mr-1" role="status" v-else>
                  <span class="sr-only">Loading...</span>
                </div>
                APAC
              </button>
              <!-- AIHG -->
              <button class="btn btn-outline-secondary btn-sm ml-1 mt-1" type="button" :disabled="$store.state.loading"
                v-if="fatura.ch_status == 'FA' && fatura.operadora.fl_sus && tem_aih" @click="gerar_arquivo('I')">
                <i class="fas fa-file-export mr-1" v-if="!$store.state.loading"></i>
                <div class="spinner-border spinner-border-sm mr-1" role="status" v-else>
                  <span class="sr-only">Loading...</span>
                </div>
                AIH
              </button>
              <!-- Marcar como enviado --->
              <button class="btn btn-secondary btn-sm ml-1 mt-1" type="button" :disabled="$store.state.loading"
                v-if="fatura.ch_status == 'FA'" @click="aguardando_protocolo(true)">
                <i class="fas fa-truck-loading mr-1"></i>
                Aguardando Protocolo
              </button>
              <button class="btn btn-outline-danger btn-sm ml-1 mt-1" type="button" :disabled="$store.state.loading"
                v-if="fatura.ch_status == 'FP'" @click="aguardando_protocolo(false)">
                <i class="fas fa-truck-loading mr-1"></i>
                Cancelar Espera
              </button>
              <button class="btn btn-primary btn-sm ml-1 mt-1" type="button" :disabled="$store.state.loading"
                v-if="fatura.ch_status == 'FA' || fatura.ch_status == 'FP'" @click="marcar_como_enviada()">
                <i class="fa fa-paper-plane mr-1" aria-hidden="true"></i>
                Marcar como Enviada
              </button>
              <button class="btn btn-outline-danger btn-sm ml-1 mt-1" type="button" :disabled="$store.state.loading"
                v-if="fatura.ch_status == 'FA'" @click="cancelar_fatura()">
                <i class="fa fa-minus-circle mr-1" aria-hidden="true"></i>
                Cancelar Fatura
              </button>
              <button class="btn btn-outline-danger btn-sm ml-1 mt-1" type="button" :disabled="$store.state.loading"
                v-if="fatura.ch_status == 'FE'" @click="cancelar_envio()">
                <i class="fa fa-ban mr-1" aria-hidden="true"></i>
                Cancelar Envio
              </button>
              <!-- Impressão -->
              <relatorios-linkados
                class="ml-1"
                pagina="fatura"
                :parms="{ 
                    fatura: fatura.id_fatura, 
                    nome_contratado: faturaNomeContratado, 
                    codigo_contratado: faturaCodigoContratado, 
                    id_contrato_operadora: faturaIdContratoOperadora,
                    unidade: faturaUnidadeOperacao, 
                    fatura_id: fatura.id_fatura, 
                    recurso_de_glosa_id: fatura.fl_reapresentacao ? fatura.id_fatura : 0, 
                }"
                :outros="lista_relatorios_linkados_outros" />

              <button class="btn btn-sm ml-1 mt-1" :class=" fatura.st_observacoes ? 'btn-primary' : 'btn-outline-primary' "
                type="button" data-toggle="tooltip" data-placement="top" title="Observações" @click="editar_observacao()">
                <i class="fa fa-comment" aria-hidden="true"></i>
              </button>

              <button class="btn btn-outline-primary btn-sm ml-1 mt-1"
                type="button" data-toggle="tooltip" data-placement="top" title="Status" @click="abrir_contatos()">
                <i class="fa-solid fa-comments"></i>
                <span class="badge badge-primary ml-1" v-if="fatura.contatos_count">
                  {{ fatura.contatos_count }}
                </span>
              </button>

              <button class="btn btn-sm btn-outline-primary ml-1 mt-1" @click="anexar()">
                <i class="fa fa-paperclip" aria-hidden="true"></i>
                <span class="badge badge-primary ml-1" v-if="fatura.arquivos.length">
                  {{ fatura.arquivos.length }}
                </span>
              </button>

              <az-file-upload
                ref="upload"
                @refresh="abrirFatura(fatura)"
                :multiple="true"
                :arquivos="fatura.arquivos"
                :parms="{ model_type: 'fatura', model_id: fatura.id_fatura }" />

            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col col-12 col-md-4">
              <az-input
                sizing="sm"
                :label="fatura.operadora.fl_sus ? 'Atendimento' : 'Operadora'"
                :edicao="false"
                :value="fatura.operadora.search"
              >
                <template v-slot:buttonposb v-if="fatura.operadora.st_site">
                  <div class="input-group-append">
                    <a
                      :href="fatura.operadora.st_site"
                      target="_blank"
                      class="btn btn-outline-primary"
                    >
                      <i class="fa fa-link" aria-hidden="true"></i>
                    </a>
                  </div>
                </template>
              </az-input>
            </div>
            <div class="col col-12 col-md-4">
              <az-input
                sizing="sm"
                label="Data de Emissão"
                :edicao="false"
                type="date"
                :value="fatura.dt_emissao">
                <template v-slot:buttonposb>
                  <div class="input-group-append" v-if="fatura.ch_status == 'FA'">
                    <button class="btn btn-outline-primary" type="button" @click="editar_emissao()">
                      <i class="fas fa-pen"></i>
                    </button>
                  </div>
                </template>
              </az-input>
            </div>
            <div class="col col-12 col-md-4">
              <az-input
                sizing="sm"
                label="Período de Atendimento"
                :edicao="false"
                :value="
                  $util.getFormatDate(fatura.dt_inicio) +
                    ' a ' +
                    $util.getFormatDate(fatura.dt_fim)
                "
              />
            </div>
          </div>
          <!-- Dados do Envio -->
          <div class="row" v-if="fatura.fatura_envio">
            <div class="col col-12 col-md-4">
              <az-input
                sizing="sm"
                label="Vencimento"
                type="date"
                :edicao="false"
                :value="fatura.fatura_envio.dt_vencimento">
                <template v-slot:buttonposb>
                  <div class="input-group-append">
                    <button class="btn btn-outline-primary" type="button" @click="editar_vencimento()">
                      <i class="fas fa-pen"></i>
                    </button>
                  </div>
                </template>
              </az-input>
            </div>
            <div class="col col-12 col-md-4">
              <az-input
                sizing="sm"
                label="Envio"
                type="date"
                :edicao="false"
                :value="fatura.fatura_envio.dt_envio">
              </az-input>
            </div>
            <div class="col col-12 col-md-2">
              <az-input
                sizing="sm"
                label="Protocolo de Entrega"
                :edicao="false"
                :value="fatura.fatura_envio.st_protocolo_entrega">
                <template v-slot:buttonposb>
                  <div class="input-group-append">
                    <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="editar_protocolo()">
                      <i class="fas fa-pen"></i>
                    </button>
                  </div>
                </template>
              </az-input>
            </div>
            <div class="col col-12 col-md-2" v-if="fatura.fatura_envio">
              <az-input
                sizing="sm"
                label="Nota Fiscal"
                :edicao="false"
                placeholder="Informar..."
                :value="fatura.fatura_envio.st_nota_fiscal">
                <template v-slot:buttonposb>
                  <div class="input-group-append">
                    <button class="btn" :class="'btn-outline-' + getNFStatusClass(fatura)" type="button" id="button-addon2" @click="editar_nota_fiscal()"
                        data-toggle="tooltip" data-placement="top" title="Emitir Nota Fiscal pelo Klingo">
                      <i v-if="fatura.nota_fiscal_link" class="fas fa-wifi" :class="'text-' + getNFStatusClass(fatura)"></i>
                      <i v-else class="fas fa-wifi"></i>
                    </button>
                    <button class="btn" :class="'btn-outline-' + getNFStatusClass(fatura)" type="button" id="button-addon2" v-if="podeEmietirNotaFiscal && (!fatura.nota_fiscal_link || (fatura.nota_fiscal_link.nota_fiscal_servico && fatura.nota_fiscal_link.nota_fiscal_servico.ch_status == '5'))" @click="informar_nota_fiscal()"
                        data-toggle="tooltip" data-placement="top" title="Informar número da Nota Fiscal">
                      <i v-if="fatura.nota_fiscal_link && (fatura.nota_fiscal_link.nota_fiscal_servico && fatura.nota_fiscal_link.nota_fiscal_servico.ch_status != '5')" class="fas fa-wifi" :class="'text-' + getNFStatusClass(fatura)"></i>
                      <i v-else class="fas fa-pen"></i>
                    </button>
                  </div>
                </template>
              </az-input>
            </div>
          </div>

          <!-- Valores -->
          <div class="row mt-2">
            <div class="col col-12 col-md-4">
              <small class="form-text text-muted text-nowrap text-truncate">Valor</small>
              <span class="text-dark lead">{{ $util.formatMoeda(fatura.valor_total.total) }}</span>
            </div>
            <div class="col col-12 col-md-4">
              <small class="form-text text-muted text-nowrap text-truncate">Impostos</small>
              <span class="text-secondary lead">{{ $util.formatMoeda(fatura.valor_total.impostos) }}</span>
            </div>
            <div class="col col-12 col-md-4">
              <small class="form-text text-muted text-nowrap text-truncate">Líquido</small>
              <span class="text-dark lead">{{ $util.formatMoeda(fatura.valor_total.liquido) }}</span>
            </div>
          </div>
          <!-- Observações -->
          <blockquote class="blockquote mt-3 mb-0" v-if="fatura.st_observacoes">
            <footer class="blockquote-footer text-nowrap text-truncate">
              {{ fatura.st_observacoes }}
            </footer>
          </blockquote>
        </div>
      </div>

      <!-- Protocolos -->
      <div class="card" v-if="lista_protocolos">
        <div class="card-header py-2 px-3">
            <div class="row">
                <div class="col col-12 col-md-10 text-truncate text-nowrap">
                    <a class="card-link" data-toggle="collapse" href="#collapseProtocolos" role="button" aria-expanded="false" aria-controls="collapseProtocolos">
                        Protocolos de Fatura
                    </a>
                </div>
                <div class="col col-12 col-md-2 text-right"></div>
            </div>
        </div>
        <div class="collapse" id="collapseProtocolos">
            <table class="table table-sm table-hover bg-light mb-0">
                <thead>
                    <tr>
                        <th width="5%">Número</th>
                        <th class="text-right">Guias</th>
                        <th class="text-right">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(guias, ip) in lista_protocolos" :key="ip" :class="( teste_search(ip) ) ? 'table-primary' : ''">
                        <td>
                            <a href="#" @click.prevent="filtrar(ip)" class="card-link">{{ ip }}</a>
                        </td>
                        <td class="text-right">{{ guias.length }}</td>
                        <td class="text-right">{{ $util.formatMoeda(totalizar_lista(guias, 'guia.valor_total.total')) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
      </div>

      <!-- Contratos -->
      <div class="card" v-if="fatura.contratos && fatura.contratos.length">
        <div class="card-header py-2 px-3">
            <div class="row">
                <div class="col col-12 col-md-10 text-truncate text-nowrap">
                    <a class="card-link" data-toggle="collapse" href="#collapseContratos" role="button" aria-expanded="false" aria-controls="collapseContratos">
                        <i class="fa-solid fa-file-contract fa-fw mr-2"></i>
                        {{ texto_contratos }}
                    </a>
                </div>
                <div class="col col-12 col-md-2 text-right">
                    Contrato
                </div>
            </div>
        </div>
        <div class="collapse" id="collapseContratos">
            <table class="table table-hover bg-light mb-0">
                <thead>
                    <tr>
                        <th width="10%">#</th>
                        <th>Contrato</th>
                        <th class="text-right">Guias</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(contrato, ic) in fatura.contratos" :key="ic" :class="( id_contrato_operadora_selec && ( id_contrato_operadora_selec == contrato.id_contrato_operadora ) ) ? 'table-primary' : ''">
                        <td>
                            #{{ contrato.id_contrato_operadora }}
                            <a href="#" @click.prevent="editar_contrato_guias(contrato)" class="card-link">
                                <i class="fa-solid fa-pen fa-fw ml-2"></i>
                            </a>
                        </td>
                        <td>
                            <a href="#" @click.prevent="( id_contrato_operadora_selec && id_contrato_operadora_selec == contrato.id_contrato_operadora ) ? id_contrato_operadora_selec = null : id_contrato_operadora_selec = contrato.id_contrato_operadora" class="card-link">
                                {{ contrato.st_descricao_arquivo_contrato }}
                            </a>
                        </td>
                        <td class="text-right">{{ contrato.qtde }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
      </div>

      <!-- FATURA ORIGINAL -->

      <div v-if="fatura.id_fatura_referencia" class="card">
        <div class="card-header">
          <span class="lead text-primary">Fatura Original</span>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col">
              {{ $util.getFormatDate(fatura.fatura_referencia.dt_emissao) }}
            </div>
            <div class="col">{{ fatura.fatura_referencia.id_fatura }}</div>
            <div class="col">
              R$ {{ $util.formatMoeda(fatura.fatura_referencia.valor_total.total) }}
            </div>
            <div class="col text-right">
              <a
                href="#"
                @click.prevent="abrirFatura(fatura.fatura_referencia)"
                class="card-link"
              >
                <i class="fas fa-folder mr-2"></i>
                Acessar
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- @REAPRESENTAÇÕES -->

        <div v-if="fatura.reapresentacoes.length" class="card">
            <div class="card-header d-flex justify-content-between py-2 px-3">
                <a class="card-link text-danger" data-toggle="collapse" href="#collapseRecursos" role="button" aria-expanded="false" aria-controls="collapseRecursos">
                    <i class="fa-solid fa-registered fa-fw mr-2"></i>
                    <span>Recursos de Glosas</span>
                </a>
                <div>
                    <span class="badge badge-secondary">
                        {{ fatura.reapresentacoes.length }}
                    </span>
                </div>
            </div>
            <div class="collapse" id="collapseRecursos">
                <div class="card-body">
                    <div v-for="(reap, irp) in fatura.reapresentacoes" :key="irp" class="row">
                        <div class="col">{{ $util.getFormatDate(reap.dt_emissao) }}</div>
                        <div class="col">{{ reap.id_fatura }}</div>
                        <div class="col">{{ reap.valor_total.items }} {{ reap.valor_total.items > 1 ? 'Itens' : 'Item' }}</div>
                        <div class="col">R$ {{ $util.formatMoeda(reap.valor_total.total) }}</div>
                        <div class="col text-right">
                        <a href="#" @click.prevent="abrirFatura(reap)" class="card-link">
                            <i class="fas fa-folder mr-2"></i>
                            Acessar
                        </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

      <!-- SUBMENU DA FATURA -->

      <div class="mb-3">
        <az-input
          type="button-group"
          :optionsList="[
            { id: 'guias', search: 'Guias' },
            { id: 'glosas', search: 'Análise de Glosa' },
            { id: 'mov', search: 'Movimentações' }
          ]"
          v-if="fatura.ch_status == 'FM' || ( fatura.fatura_creditos && fatura.fatura_creditos.length )"
          v-model="viewMode" />
      </div>

      <!-- Itens da Reapresentação -->

      <template v-if="fatura.fl_reapresentacao">

        <template v-if="viewMode == 'guias' || viewMode == 'glosas'">

          <div>
            <div class="row mb-2">
              <div class="col col-12" :class="viewMode == 'guias' ? 'col-md-8' : ''">
                <az-input sizing="sm" icon="fa fa-search" v-model="search">
                    <template v-slot:buttonposb>
                        <div class="input-group-append" v-if="fatura && fatura.fl_reapresentacao">
                            <button class="btn btn-outline-secondary px-1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fa-solid fa-ellipsis-vertical"></i>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a class="dropdown-item" href="#" @click.prevent="view_motivo_glosa = ''">
                                    <i class="fa-solid fa-square-check fa-fw mr-2" v-if="!view_motivo_glosa"></i>
                                    <i class="fa-solid fa-square fa-fw mr-2" v-else></i>
                                    Não Exibir
                                </a>
                                <a class="dropdown-item" href="#" @click.prevent="view_motivo_glosa = 'M'">
                                    <i class="fa-solid fa-square-check fa-fw mr-2" v-if="view_motivo_glosa == 'M'"></i>
                                    <i class="fa-solid fa-square fa-fw mr-2" v-else></i>
                                    Exibir Motivo de Glosa
                                </a>
                                <a class="dropdown-item" href="#" @click.prevent="view_motivo_glosa = 'J'">
                                    <i class="fa-solid fa-square-check fa-fw mr-2" v-if="view_motivo_glosa == 'J'"></i>
                                    <i class="fa-solid fa-square fa-fw mr-2" v-else></i>
                                    Exibir Justificativa
                                </a>
                            </div>
                        </div>
                    </template>
                </az-input>
              </div>

              <div class="col col-12 col-md-4" v-if="viewMode == 'guias'">
                <az-input
                  sizing="sm"
                  type="button-group"
                  :optionsList="[
                    { id: 'T', search: 'Todas' },
                    { id: 'G', search: 'Glosadas' },
                    { id: 'R', search: 'Recebidas' },
                    { id: 'A', search: 'A Receber' },
                  ]"
                  optionsData="id"
                  v-model="filtro_valor" />
              </div>
            </div>
          </div>

          <div class="progress mb-3">
            <div class="progress-bar bg-danger" role="progressbar" :style="'width: ' + totais_guias.perc_glosado + '%'"></div>
            <div class="progress-bar bg-primary" role="progressbar" :style="'width: ' + totais_guias.perc_recebido + '%'"></div>
            <div class="progress-bar" :class="viewMode == 'glosas' ? 'bg-dark' : 'bg-success'" role="progressbar" :style="'width: ' + totais_guias.perc_a_receber + '%'"></div>
          </div>

          <table class="table table-responsive-md table-hover bg-light table-sm w3-animate-opacity" v-if="fatura.item_reapresentacaos.length">
            <thead>
              <tr>
                <th></th>
                <table-th title="Data" v-model="ordem" sortby="guia.dt_criacao"></table-th>
                <table-th title="Guia" v-model="ordem" sortby="guia.guia_formatada"></table-th>
                <table-th title="Tipo" v-model="ordem" sortby="nome"></table-th>
                <table-th title="Paciente" v-model="ordem" sortby="guia.atendimento.paciente.st_nome"></table-th>
                <table-th title="Código" v-model="ordem" sortby="codigo"></table-th>
                <table-th title="Procedimento" v-model="ordem" sortby="descricao"></table-th>
                <th class="text-right">Valor</th>
                <th class="text-right">Glosado</th>
                <th class="text-right">{{ viewMode == "glosas" ? "Acatado" : "Recebido" }}</th>
                <th class="text-right">{{ viewMode == "glosas" ? "Reapresenta" : "A Receber" }}</th>
                <td class="text-right">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="selectAll"
                      id="defaultCheck1"
                      @change="onSelectAll()"
                    />
                  </div>
                </td>
              </tr>
            </thead>
            <tbody>
              <!-- Total Reapresentação -->
              <tr class="table-primary">
                <td></td>
                <td>Total</td>
                <td>{{ lista_reap.length }} item(ns)</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="text-right">
                  {{ $util.formatMoeda(valor_total.total) }}
                </td>
                <td class="text-right text-danger">
                  {{ $util.formatMoeda(valor_total.glosado) }}
                </td>
                <td class="text-right" :class="viewMode == 'glosas' ? 'text-danger' : 'text-primary'">
                  {{ $util.formatMoeda(valor_total.recebido) }}
                  <div v-if="valor_total.a_mais">
                    <small class="small text-muted">
                        <i class="fa-solid fa-circle-plus mr-1"></i>
                        {{ $util.formatMoeda(valor_total.a_mais) }}
                    </small>
                  </div>
                </td>
                <td class="text-right" :class="viewMode == 'glosas' ? 'text-danger' : 'text-success'">
                  {{ $util.formatMoeda(valor_total.a_receber) }}
                </td>
                <td></td>
              </tr>
              <!-- Total Selecionado Reapresentação -->
              <tr class="table-info">
                <td></td>
                <td>Selecionado</td>
                <td>{{ selecteds.length }} guia(s)</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="text-right">
                  {{ $util.formatMoeda(valor_selecionado.total) }}
                </td>
                <td class="text-right text-danger">
                  {{ $util.formatMoeda(valor_selecionado.glosado) }}
                </td>
                <td class="text-right" :class="viewMode == 'glosas' ? 'text-danger' : 'text-primary'">
                  {{ $util.formatMoeda(valor_selecionado.recebido) }}
                </td>
                <td class="text-right" :class="viewMode == 'glosas' ? 'text-danger' : 'text-success'">
                  {{ $util.formatMoeda(valor_selecionado.a_receber) }}
                </td>
                <td></td>
              </tr>
              <!-- Itens Reapresentação -->
              <tr :key="ig" class="table-light" v-for="(item_reap, ig) in lista_reap">
                <td class="text-nowrap">
                  <span class="badge" :class="'badge-' + item_reap.status_color" data-toggle="tooltip" data-placement="top"
                    :title="item_reap.guia.status">
                    {{ item_reap.ch_status }}
                  </span>
                </td>
                <td>{{ $util.getFormatDate(item_reap.guia.dt_criacao) }}</td>
                <td>
                  <a href="#" class="card-link" @click.prevent="editar_guia(item_reap.guia)">{{ item_reap.guia.guia_formatada }}</a>
                  <a href="#" class="card-link" :class="item_reap.st_protocolo_recurso ? '' : 'text-muted'" @click.prevent="editar_protocolo_reap_guia(item_reap)">
                    <i class="fas fa-stamp ml-1"></i>
                  </a>
                </td>
                <td class="text-nowrap">
                  <small>{{ item_reap.guia.nome }}</small>
                </td>
                <td>
                  <small>{{ item_reap.guia.atendimento.paciente.st_nome }}</small>
                </td>
                <td>
                  <small>{{ item_reap.codigo }}</small></td>
                <td>
                    <small>{{ item_reap.descricao }}</small>
                    <span class="badge badge-secondary ml-2" v-if="item_reap.quantidade > 1">
                        x{{ item_reap.quantidade }}
                    </span>
                    <a href="#" class="card-link" :class="item_reap.st_justificativa ? 'text-primary' : 'text-muted'"
                        @click.prevent="editar_justificativa(item_reap)">
                        <i class="far fa-file-alt ml-2"></i>
                    </a>
                    <div v-if="view_motivo_glosa == 'J' && item_reap.st_justificativa" class="small text-muted">
                        <a href="#" @click.prevent="filtrar(item_reap.st_justificativa)" class="card-link text-muted">
                            {{ item_reap.st_justificativa }}
                        </a>
                    </div>

                    <div v-else-if="view_motivo_glosa == 'M' && item_reap.atendimento_procedimento_guia && item_reap.atendimento_procedimento_guia.retorno_fatura && item_reap.atendimento_procedimento_guia.retorno_fatura.motivo_glosa" class="small text-muted">
                        <a href="#" @click.prevent="filtrar(item_reap.atendimento_procedimento_guia.retorno_fatura.motivo_glosa.search)" class="card-link text-muted">
                            {{ item_reap.atendimento_procedimento_guia.retorno_fatura.motivo_glosa.search }}
                        </a>
                    </div>

                    <div v-else-if="view_motivo_glosa == 'M' && item_reap.consumo_procedimento_guia && item_reap.consumo_procedimento_guia.retorno_fatura && item_reap.consumo_procedimento_guia.retorno_fatura.motivo_glosa" class="small text-muted">
                        <a href="#" @click.prevent="filtrar(item_reap.consumo_procedimento_guia.retorno_fatura.motivo_glosa.search)" class="card-link text-muted">
                            {{ item_reap.consumo_procedimento_guia.retorno_fatura.motivo_glosa.search }}
                        </a>
                    </div>
                </td>
                <!-- @@@@ -->
                <td class="text-right"><span v-if="true">{{ $util.formatMoeda(item_reap.valor_total.total) }}</span></td>
                <td class="text-right" :class="item_reap.valor_total.glosado ? 'text-danger' : 'text-muted'">
                  {{ $util.formatMoeda(item_reap.valor_total.glosado) }}
                </td>

                <td class="text-right" :class="coluna3(item_reap.valor_total) ? viewMode == 'glosas' ? 'text-danger' : 'text-primary' : 'text-muted' ">
                  <az-input
                    sizing="sm"
                    type="money"
                    v-if="item_reap.selected && !item_reap.valor_total.calcular && viewMode == 'guias'"
                    v-model="item_reap.valor_total.recebido_editar" />

                  <az-input
                    sizing="sm"
                    type="money"
                    v-if="item_reap.selected && !item_reap.valor_total.calcular && viewMode == 'glosas'"
                    v-model="item_reap.valor_total.acatado_editar" />

                  <span class="text-danger" v-else-if="( !item_reap.selected || item_reap.valor_total.calcular ) && viewMode == 'glosas'" >
                    {{ $util.formatMoeda(item_reap.valor_total.acatado) }}
                  </span>

                  <span class="text-primary" v-else-if="( !item_reap.selected || item_reap.valor_total.calcular ) && viewMode != 'glosas'">
                    {{ $util.formatMoeda(item_reap.valor_total.recebido) }}
                  </span>
                </td>
                <td class="text-right" :class=" coluna4(item_reap.valor_total) ? viewMode == 'glosas' ? 'text-danger' : 'text-success' : 'text-muted' ">
                  {{ $util.formatMoeda(coluna4(item_reap.valor_total)) }}
                </td>
                <td class="text-right">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="item_reap.selected" @change="selectAll = false" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

        </template>

        <!-- SubMenu de Guias em Reapresentação -->
        <nav class="navbar fixed-bottom navbar-light bg-light" id="menu-guias" v-if="viewMode == 'guias'">
          <div>
            <button class="btn btn-secondary mr-2" type="button" @click=" fatura = null; $emit('fechar'); ">
              Fechar
            </button>
            <button class="btn btn-outline-secondary mr-2" @click="$util.logAudit('fatura', fatura.id_fatura)" v-if="fatura.id_fatura">
              Log
            </button>
          </div>
          <div class="mr-3">
            <div class="progress mt-0 mb-1">
              <div class="indeterminate" v-if="$store.state.loading"></div>
              <div class="determinate" v-else></div>
            </div>
            <button class="btn btn-sm ml-1" type="button" :class="desabilitar('justificar') ? 'btn-outline-secondary' : 'btn-dark'"
              data-toggle="tooltip" data-placement="top" title="Justificar reapresentação"
              :disabled="desabilitar('justificar')" id="justificar" @click="justificar_reapresentacao()">
              <i class="far fa-file-alt"></i>
            </button>
            <button class="btn btn-sm ml-1" type="button" :class="desabilitar('remover') ? 'btn-outline-secondary' : 'btn-dark'"
              data-toggle="tooltip" data-placement="top" title="Remover da Fatura"
              :disabled="desabilitar('remover')" id="remover" @click="retirar_da_fatura()">
              <i class="fas fa-upload"></i>
            </button>
            <button class="btn btn-sm ml-1" type="button" :class=" desabilitar('pendenciar') ? 'btn-outline-secondary' : 'btn-warning' "
              data-toggle="tooltip" data-placement="top" title="Adicionar Pendência" :disabled="desabilitar('pendenciar')"
              id="pendenciar" v-if="false">
              <i class="fas fa-exclamation-circle"></i>
            </button>
            <button class="btn btn-sm ml-1" type="button" :class=" desabilitar('cancelar-mov') ? 'btn-outline-secondary' : 'btn-danger' "
              data-toggle="tooltip" data-placement="top" title="Cancelar Movimentação" :disabled="desabilitar('cancelar-mov')"
              @click="cancelar_mov()" id="cancelar-mov">
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
            <button class="btn btn-sm ml-1" type="button" :class=" desabilitar('glosar') ? 'btn-outline-secondary' : 'btn-danger' "
              data-toggle="tooltip" data-placement="top" title="Glosar" :disabled="desabilitar('glosar')"
              @click="glosar_guias()" id="glosar">
              <i class="fas fa-ban"></i>
            </button>
            <button class="btn btn-sm ml-1" type="button" :class=" desabilitar('receber') ? 'btn-outline-secondary' : 'btn-primary' "
              data-toggle="tooltip" data-placement="top" title="Atribuir Recebimento"
              :disabled="desabilitar('receber')" @click="receber()"
              id="receber"
            >
              <i class="fas fa-donate"></i>
            </button>
          </div>
        </nav>

        <!-- SubMenu de Glosas em Reapresentação -->
        <nav class="navbar fixed-bottom navbar-light bg-light" id="menu-guias" v-else-if="viewMode == 'glosas'">
          <div>
            <button class="btn btn-secondary mr-2" type="button" @click=" fatura = null; $emit('fechar'); ">
              Fechar
            </button>
            <button class="btn btn-outline-secondary mr-2" @click="$util.logAudit('fatura', fatura.id_fatura)" v-if="fatura.id_fatura">
              Log
            </button>
          </div>
          <div class="mr-3">
            <div class="progress mt-0 mb-1">
              <div class="indeterminate" v-if="$store.state.loading"></div>
              <div class="determinate" v-else></div>
            </div>

            <button class="btn btn-sm ml-1" type="button" :class=" desabilitar_reap('add_reap') ? 'btn-outline-secondary' : 'btn-dark' "
              data-toggle="tooltip" data-placement="top" title="Adicionar ao Recurso de Glosa" :disabled="desabilitar_reap('add_reap')"
              id="add_reap" name="add_reap" key="add_reap" @click="add_reapresantecao()">
              <i class="fas fa-download"></i>
            </button>
            <button class="btn btn-sm ml-1" type="button" :class=" desabilitar_reap('criar_reap') ? 'btn-outline-secondary' : 'btn-danger' "
              data-toggle="tooltip" data-placement="top" title="Criar Envio de Recurso de Glosa" :disabled="desabilitar_reap('criar_reap')"
              id="criar_reap" key="criar_reap" @click="reapresentar()" >
              <i class="fas fa-folder-plus"></i>
            </button>
            <button class="btn btn-sm ml-1" type="button" :class=" desabilitar_reap('cancelar-analise') ? 'btn-outline-secondary' : 'btn-danger' "
              data-toggle="tooltip" data-placement="top" title="Cancelar Análise" :disabled="desabilitar_reap('cancelar-analise')"
              @click="analisar_glosa('cancelar')" id="cancelar-analise" key="cancelar-analise">
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
            <button class="btn btn-sm ml-1" type="button" :class=" desabilitar_reap('acatar-tudo') ? 'btn-outline-secondary' : 'btn-danger' "
              data-toggle="tooltip" data-placement="top" title="Acatar Tudo" :disabled="desabilitar_reap('acatar-tudo')"
              @click="acatar_justificativa()" id="acatar-tudo" key="acatar-tudo"> <!-- analisar_glosa('acatar') -->
              <i class="fa fa-check" aria-hidden="true"></i>
            </button>
            <button class="btn btn-sm ml-1" type="button" :class=" desabilitar_reap('acatar-tudo') ? 'btn-outline-secondary' : 'btn-success' "
              data-toggle="tooltip" data-placement="top" title="Atualizar Selecionados" :disabled="desabilitar_reap('acatar-tudo')"
              @click="analisar_glosa('acatar-info')" id="acatar-selecionado" key="acatar-selecionado">
              <i class="far fa-save"></i>
            </button>

          </div>
        </nav>

        <!-- SubMenu de Glosas em Reapresentação -->
        <nav class="navbar fixed-bottom navbar-light bg-light" id="menu-guias" v-else>
          <div>
            <button class="btn btn-secondary mr-2" type="button" @click=" fatura = null; $emit('fechar'); ">
              Fechar
            </button>
            <button class="btn btn-outline-secondary mr-2" @click="$util.logAudit('fatura', fatura.id_fatura)" v-if="fatura.id_fatura">
              Log
            </button>
          </div>
        </nav>

        <!-- Modal Justificativa de Reapresentação -->
        <div class="modal fade" id="justificativaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Justificativa</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <az-input
                  type="textarea"
                  rows="5"
                  v-model="justificativa.texto" />
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                <az-submit @click="salvar_justificar_reapresentacao()">Atualizar</az-submit>
              </div>
            </div>
          </div>
        </div>

      </template>

      <!-- @GUIAS DA FATURA -->

      <template v-else>

        <div v-if="viewMode == 'guias' || viewMode == 'glosas'">
          <div class="form-row mb-2">
            <div class="col col-12" :class="viewMode == 'guias' ? 'col-md-8' : ''">
              <az-input sizing="sm" icon="fa fa-search" v-model="search">
                <template v-slot:buttonposb>
                  <div class="input-group-append input-group-sm" v-if="search">
                    <button class="btn btn-outline-secondary btn-sm" type="button" @click="search = ''">
                      <i class="fas fa-eraser"></i>
                    </button>
                  </div>
                </template>
              </az-input>
            </div>

            <div class="col col-12 col-md-4" v-if="viewMode == 'guias'">
                <az-input
                  sizing="sm"
                  type="button-group"
                  :optionsList="[
                    { id: 'T', search: 'Todas' },
                    { id: 'G', search: 'Glosadas' },
                    { id: 'R', search: 'Recebidas' },
                    { id: 'A', search: 'A Receber' },
                  ]"
                  optionsData="id"
                  v-model="filtro_valor" />
              </div>
          </div>

          <div class="progress mb-3">
            <div class="progress-bar bg-danger" role="progressbar" :style="'width: ' + totais_guias.perc_glosado + '%'"></div>
            <div class="progress-bar bg-primary" role="progressbar" :style="'width: ' + totais_guias.perc_recebido + '%'"></div>
            <div class="progress-bar" :class="viewMode == 'glosas' ? 'bg-dark' : 'bg-success'" role="progressbar" :style="'width: ' + totais_guias.perc_a_receber + '%'"></div>
          </div>

          <table class="table table-responsive-md table-hover bg-light table-sm w3-animate-opacity" v-if="fatura.guia_faturas.length">
            <thead>
              <tr>
                <th></th>
                <table-th title="Data" v-model="ordem" sortby="guia.dt_criacao"></table-th>
                <table-th title="Guia" v-model="ordem" sortby="guia.guia_formatada"></table-th>
                <table-th title="Tipo" v-model="ordem" sortby="nome"></table-th>
                <table-th title="Paciente" v-model="ordem" sortby="guia.atendimento.paciente.st_nome"></table-th>
                <table-th title="Prof." v-model="ordem" sortby="guia.atendimento.medico.st_nome_exibicao"></table-th>
                <th class="text-right">Valor</th>
                <th class="text-right">Glosado</th>
                <th class="text-right">{{ viewMode == "glosas" ? "Acatado" : "Recebido" }}</th>
                <th class="text-right">{{ viewMode == "glosas" ? "Reapresentado" : "A Receber" }}</th>
                <td class="text-right">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="selectAll"
                      id="defaultCheck1"
                      @change="onSelectAll()"
                    />
                  </div>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr class="table-primary">
                <td></td>
                <td>Total</td>
                <td>{{ lista.length }} guia(s)</td>
                <td></td>
                <td></td>
                <td></td>
                <td class="text-right">{{ $util.formatMoeda(valor_total.total) }}</td>
                <td class="text-right text-danger">{{ $util.formatMoeda(valor_total.glosado) }}</td>
                <td class="text-right" :class="viewMode == 'glosas' ? 'text-danger' : 'text-primary'">
                    {{ $util.formatMoeda(valor_total.recebido) }}
                    <div v-if="valor_total.a_mais">
                        <small class="small text-muted">
                            <i class="fa-solid fa-circle-plus mr-1"></i>
                            {{ $util.formatMoeda(valor_total.a_mais) }}
                        </small>
                    </div>
                </td>
                <td class="text-right" :class="viewMode == 'glosas' ? 'text-primary' : 'text-success'">{{ $util.formatMoeda(valor_total.a_receber) }}</td>
                <td></td>
              </tr>
              <tr class="table-info">
                <td></td>
                <td>Selecionado</td>
                <td>{{ selecteds.length }} guia(s)</td>
                <td></td>
                <td></td>
                <td></td>
                <td class="text-right">
                  {{ $util.formatMoeda(valor_selecionado.total) }}
                </td>
                <td class="text-right text-danger">
                  {{ $util.formatMoeda(valor_selecionado.glosado) }}
                </td>
                <td class="text-right" :class="viewMode == 'glosas' ? 'text-danger' : 'text-primary'">
                  {{ $util.formatMoeda(valor_selecionado.recebido) }}
                  <div v-if="valor_selecionado.a_mais">
                        <small class="small text-muted">
                            <i class="fa-solid fa-circle-plus mr-1"></i>
                            {{ $util.formatMoeda(valor_selecionado.a_mais) }}
                        </small>
                  </div>
                </td>
                <td
                  class="text-right"
                  :class="viewMode == 'glosas' ? 'text-primary' : 'text-success'"
                >
                  {{ $util.formatMoeda(valor_selecionado.a_receber) }}
                </td>
                <td></td>
              </tr>
              <template v-for="(guia, ig) in lista">
                <tr :key="ig" class="table-light" v-if="true">
                  <td class="text-nowrap">
                    <a href="#" class="text-secondary mr-2" @click.prevent="expandir_guia(guia)">
                      <i class="far fa-plus-square" aria-hidden="true" v-if="!guia.guia.expanded"></i>
                      <i class="far fa-minus-square" aria-hidden="true" v-if="guia.guia.expanded"></i>
                    </a>
                    <a href="#" @click.prevent="filtrar(guia.guia.ch_status)">
                      <span class="badge" :class="'badge-' + guia.guia.status_color" data-toggle="tooltip"
                        data-placement="top" :title="guia.guia.status">
                        {{ guia.guia.ch_status }}
                      </span>
                    </a>
                  </td>
                  <td>{{ $util.getFormatDate(guia.guia.dt_criacao) }}</td>
                  <td>
                    <a href="#" class="card-link" @click.prevent="editar_guia(guia.guia)">{{ guia.guia.guia_formatada }}</a>
                  </td>
                  <td class="text-nowrap">
                    <a href="#" @click.prevent="filtrar(guia.guia.nome)">
                      <small>{{ guia.guia.nome }}</small>
                    </a>
                    <span class="badge badge-secondary" v-if="guia.guia.valor_total.items">{{ guia.guia.valor_total.items }}</span>
                    
                    <span class="ml-1" v-if="guia.guia.ch_tipo_guia == 'A' && !guia.guia.st_codigo_autorizacao" title="Número da APAC não informado.">
                      <i class="fa-solid fa-circle-question text-warning"></i>
                    </span>

                    <span class="ml-1" v-else-if="guia.guia.ch_tipo_guia == 'I' && !guia.guia.st_codigo_autorizacao" title="Número da AIH não informado.">
                      <i class="fa-solid fa-circle-question text-warning"></i>
                    </span>

                    <span class="text-muted small ml-2" v-if="( exibir_protocolo || 1==1 ) && guia.guia.guia_recebimentos && guia.guia.guia_recebimentos.length" title="Protocolos">
                        <a href="#" @click.prevent="filtrar(guia.guia.guia_recebimentos.map((gr) => gr.protocolo_id).join(', '))" v-if="guia.guia.guia_recebimentos.length == 1" class="card-link">
                            {{ guia.guia.guia_recebimentos.map((gr) => gr.protocolo_id).join(', ') }}    
                        </a>
                        <template v-else>
                            {{ guia.guia.guia_recebimentos.map((gr) => gr.protocolo_id).join(', ') }}
                        </template>
                    </span>    
                  </td>
                  <td>
                    <a href="#" @click.prevent="filtrar(guia.guia.atendimento.paciente.st_nome)">
                      <small>{{ guia.guia.atendimento.paciente.st_nome }}</small>
                    </a>
                  </td>
                  <td>
                    <a href="#" @click.prevent="filtrar(guia.guia.atendimento.medico.st_nome_exibicao)">
                      <small>{{ guia.guia.atendimento.medico.st_nome_exibicao }}</small>
                    </a>
                  </td>
                  <td class="text-right">
                    {{ $util.formatMoeda(guia.guia.valor_total.total) }}
                  </td>
                  <td class="text-right" :class="guia.guia.valor_total.glosado ? 'text-danger' : 'text-muted'">
                    <span v-if="viewMode == 'guias' && guia.guia.valor_total.reapresentado > 0">
                      <i class="fas fa-registered text-warning mr-1"></i>
                    </span>
                    <span v-else-if="guia.guia.valor_total.prazo_recurso !== false && guia.guia.valor_total.glosado > guia.guia.valor_total.acatado" class="badge badge-danger mr-1"
                      data-toggle="tooltip" data-placement="top" title="Prazo para Recurso de Glosa">
                      {{ guia.guia.valor_total.prazo_recurso }}d
                    </span>
                    {{ $util.formatMoeda(guia.guia.valor_total.glosado) }}
                  </td>
                  <td class="text-right" :class=" coluna3(guia.guia.valor_total) ? viewMode == 'glosas' ? 'text-danger' : 'text-primary' : 'text-muted' ">
                    {{ $util.formatMoeda(coluna3(guia.guia.valor_total)) }}
                    <div v-if="viewMode != 'glosas' && guia.guia.valor_total.a_mais">
                        <small class="small text-muted">
                            <i class="fa-solid fa-circle-plus mr-1"></i>
                            {{ $util.formatMoeda(guia.guia.valor_total.a_mais) }}
                        </small>
                    </div>
                  </td>
                  <td class="text-right" :class=" coluna4(guia.guia.valor_total) ? viewMode == 'glosas' ? 'text-primary' : 'text-success' : 'text-muted' ">
                    {{ $util.formatMoeda(coluna4(guia.guia.valor_total)) }}
                  </td>
                  <td class="text-right">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" v-model="guia.guia.selected" id="defaultCheck1" @change="selectAll = false" />
                    </div>
                  </td>
                </tr>

                <!-- Items da Guia / Expansível -->
                <tr v-if="guia.guia.expanded" :key="'d' + ig">
                  <td></td>
                  <td>
                    <small>Código</small>
                  </td>
                  <td colspan="7">
                    <small>Descrição</small>
                  </td>
                  <td colspan="2" class="text-right">
                    <small>Cód Glosa</small>
                  </td>
                </tr>
                <template v-if="guia.guia.expanded">
                  <template v-for="(proc, ipr) in guia.guia.atendimento_procedimento_guias">
                    <tr :key="'d' + ig + '-' + ipr" v-if="viewMode != 'glosas' || proc.retorno.dc_valor_glosa > 0">
                      <td>
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" v-model="proc.selected" id="defaultCheck1" v-if="guia.guia.ch_status != 'EF'"/>
                        </div>
                      </td>
                      <td>{{ proc.st_codigo ? proc.st_codigo : ( proc.item_tabela ? proc.item_tabela.st_codigo : proc.st_codigo_sus ) }}</td>
                      <td colspan="4">
                        {{ proc.item_tabela ? proc.item_tabela.st_nome : proc.st_procedimento }} 
                        <span class="badge badge-secondary mx-2" v-if="proc.in_quantidade > 1"
                          data-toggle="tooltip" data-placement="top" title="Quantidade">
                          x{{ proc.in_quantidade }}
                        </span>
                        <a v-if="proc.atendimento_procedimento && proc.atendimento_procedimento.id_atendimento_pacote" class="ml-2" href="#" @click.prevent="ver_pacote(guia.guia)" title="Ver Pacote">
                            <i class="fas fa-layer-group"></i>
                        </a>

                        <small class="ml-2" v-if="proc.grau_participacao">
                          {{ proc.grau_participacao.search }}
                        </small>

                        <small class="text-muted ml-2" v-if="proc.retorno && proc.retorno.motivo_glosa && proc.retorno.dc_valor_glosa > 0">
                          {{ proc.retorno.motivo_glosa.st_descricao }}
                        </small>
                      </td>
                      <td class="text-right">
                        {{ $util.formatMoeda(proc.valor_total) }}
                      </td>
                      <td class="text-right" :style="'max-width: ' + ( proc.in_quantidade > 1 ? '140' : '80' ) + 'px;'">
                        <az-input
                          sizing="sm"
                          :type="proc.retorno.calc_qtd ? 'text' : 'money'"
                          v-if="proc.selected && viewMode == 'guias'"
                          v-model="proc.retorno.valor_glosa_editar"
                          @input="calcular_valor_item(proc)">
                          <template v-slot:button-pre>
                            <input type="number" class="form-control" placeholder="Qtd" v-model="proc.retorno.qtde_glosa_editar" v-if="proc.in_quantidade > 1"
                              @input="calcular_qtde_item(proc)" style="max-width: 60px">
                          </template>
                        </az-input>
                        <span class="text-danger" v-else>
                            <a href="#" @click.prevent="ver_retorno_datas(proc, guia)" v-if="proc.retorno && proc.retorno.js_datas && proc.retorno.js_datas.length > 0" class="mr-1" title="Visualizar datas.">
                                <i class="fa-regular fa-calendar-day"></i>
                            </a>

                            <a href="#" @click.prevent="ver_retorno_datas(proc, guia)" v-else-if="proc.retorno && proc.retorno.dc_valor_glosa > 0 && proc.retorno.dc_valor_glosa <= proc.valor_total && proc.in_quantidade > 1" class="mr-1" title="Visualizar datas.">
                                <i class="fa-regular fa-calendar-day" :class="proc.retorno.js_datas && proc.retorno.js_datas.length > 0 ? 'text-primary' : 'text-secondary'"></i>
                            </a>

                            <span class="badge badge-secondary mr-1" v-if="proc.retorno.in_quantidade > 0">x{{ proc.retorno.in_quantidade }}</span>
                            {{ $util.formatMoeda(proc.retorno.dc_valor_glosa) }}
                        </span>
                      </td>
                      <td class="text-right" style="max-width: 80px;">
                        <az-input
                          sizing="sm"
                          type="money"
                          v-if="proc.selected && !proc.retorno.calcular && viewMode == 'guias'"
                          v-model="proc.retorno.valor_liberado_editar" />

                        <az-input
                          sizing="sm"
                          type="money"
                          v-if="proc.selected && !proc.retorno.calcular && viewMode == 'glosas'"
                          v-model="proc.acatado_editar" />

                        <span class="text-danger" v-else-if="( !proc.selected || proc.retorno.calcular ) && viewMode == 'glosas'" >
                          {{ $util.formatMoeda(proc.dc_valor_glosado) }}
                        </span>

                        <span class="text-primary" v-else-if="( !proc.selected || proc.retorno.calcular ) && viewMode != 'glosas'">
                          {{ $util.formatMoeda(proc.retorno.dc_valor_liberado) }}

                          <div v-if="proc.retorno.dc_valor_a_mais">
                            <small class="small text-muted">
                                <i class="fa-solid fa-circle-plus mr-1"></i>
                                {{ $util.formatMoeda(proc.retorno.dc_valor_a_mais) }}
                            </small>
                          </div>
                        </span>
                      </td>
                      <td class="text-right">
                        <span class="text-danger" v-if="viewMode == 'glosas'">
                          {{ $util.formatMoeda(proc.valor_reapresentado) }}
                        </span>
                        <span class="text-success" v-else>
                          {{ $util.formatMoeda( Math.round((proc.valor_total - proc.retorno.dc_valor_glosa - proc.retorno.dc_valor_liberado) * 100) / 100 ) }}
                        </span>
                      </td>
                      <td class="text-center" style="width: 80px;">
                        <az-input
                          sizing="sm"
                          type="autocomplete"
                          service="motivos_glosa.index"
                          :optionsName="'motivos_glosa.index.' + fatura.id_operadora"
                          :optionsParm="{ id_operadora: fatura.id_operadora }"
                          optionsMode="aql"
                          optionsDisplay="search"
                          optionsPosition="center"
                          :optionsInitial="
                            proc.retorno && proc.retorno.motivo_glosa
                              ? proc.retorno.motivo_glosa.in_codigo
                              : ''
                          "
                          :optionsSync="false"
                          v-if="proc.selected && viewMode == 'guias'"
                          :required="proc.retorno.valor_glosa_editar > 0"
                          v-model="proc.retorno.motivo_glosa">
                          <template v-slot:buttonposb>
                            <div class="input-group-prepend input-group-sm" v-if="proc.retorno.motivo_glosa">
                                <button class="btn btn-outline-secondary btn-sm px-1" type="button" data-toggle="tooltip" data-placement="top"
                                    title="Copiar para os demais items." @click="copiar_motivo_glosa(guia.guia, proc.retorno.motivo_glosa)">
                                    <i class="fas fa-arrows-alt-v"></i>
                                </button>
                            </div>
                          </template>
                        </az-input>
                        <span v-else-if="proc.retorno.motivo_glosa">{{ proc.retorno.motivo_glosa.in_codigo }}</span>
                      </td>
                    </tr>
                    <!-- Justificativa de Acatamento da Glosa -->
                    <tr v-if="proc.selected && !proc.retorno.calcular && viewMode == 'glosas' && proc.acatado_editar" :key="'j' + ig + '-' + ipr">
                      <td></td>
                      <td colspan="9">
                        <az-input
                          label="Acatar: Jusitificativa"
                          sizing="sm"
                          :compact="true"
                          v-model="proc.justificativa_editar" />
                      </td>
                    </tr>
                    <tr v-else-if="viewMode == 'glosas' && proc.dc_valor_glosado && proc.st_acatar_justificativa" :key="'jg' + ig + '-' + ipr">
                      <td></td>
                      <td colspan="9">
                        <small>
                          <span class="text-muted">Acatar Jusitificativa:</span>
                          {{ proc.st_acatar_justificativa }}
                        </small>
                      </td>
                    </tr>
                    <!-- CONSUMOS - MAT/MED/TAXA -->
                    <template v-if="proc.consumo_procedimentos && proc.consumo_procedimentos.length">
                      <template v-for="(consumo, icx) in proc.consumo_procedimentos">
                        <tr :key="'m' + ig + '-' + ipr + '-' + icx" v-if="viewMode != 'glosas' || consumo.retorno.dc_valor_glosa > 0">
                          <td>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" v-model="consumo.selected" id="defaultCheck1" v-if="guia.guia.ch_status != 'EF'"/>
                            </div>
                          </td>
                          <td>{{ consumo.st_codigo ? consumo.st_codigo : ( consumo.dados ? consumo.dados.codigo : '' ) }}</td>
                          <td colspan="4">
                            {{ consumo.dados ? consumo.dados.descricao : '' }}
                            <span class="badge badge-secondary mx-2" v-if="consumo.dc_quantidade > 1"
                                data-toggle="tooltip" data-placement="top" title="Quantidade">
                              x{{ $util.formatMoeda(consumo.dc_quantidade, 3, 0) }}
                            </span>
                            <small class="text-muted ml-2" v-if="consumo.retorno && consumo.retorno.motivo_glosa && consumo.retorno.dc_valor_glosa > 0">
                              {{ consumo.retorno.motivo_glosa.st_descricao }}
                            </small>
                          </td>
                          <td class="text-right">
                            {{ $util.formatMoeda(consumo.valor_total) }}
                          </td>
                          <td class="text-right" :style="'max-width: ' + ( consumo.dc_quantidade > 1 ? '140' : '80' ) + 'px;'">
                            <az-input
                              sizing="sm"
                              :type="consumo.retorno.calc_qtd ? 'text' : 'money'"
                              v-if="consumo.selected && viewMode == 'guias'"
                              v-model="consumo.retorno.valor_glosa_editar"
                              @input="calcular_valor_item(consumo)">
                              <template v-slot:button-pre>
                                <input type="number" class="form-control" placeholder="Qtd" v-model="consumo.retorno.qtde_glosa_editar"
                                  v-if="consumo.dc_quantidade > 1" @input="calcular_qtde_item(consumo)" style="max-width: 60px">
                              </template>
                            </az-input>
                            <span class="text-danger" v-else>
                              <span class="badge badge-secondary mr-1" v-if="consumo.retorno.in_quantidade > 0">x{{ consumo.retorno.in_quantidade }}</span>
                              {{ $util.formatMoeda(consumo.retorno.dc_valor_glosa) }}
                            </span>
                          </td>
                          <td class="text-right" style="max-width: 80px;">
                            <az-input
                              sizing="sm"
                              type="money"
                              v-if="consumo.selected && !consumo.retorno.calcular && viewMode == 'guias'"
                              v-model="consumo.retorno.valor_liberado_editar" />

                            <az-input
                              sizing="sm"
                              type="money"
                              v-else-if="consumo.selected && !consumo.retorno.calcular && viewMode == 'glosas'"
                              v-model="consumo.acatado_editar" />

                            <span class="text-danger" v-else-if="viewMode == 'glosas'">{{ $util.formatMoeda(consumo.dc_valor_glosado) }}</span>
                            <span class="text-primary" v-else>
                                {{ $util.formatMoeda(consumo.retorno.dc_valor_liberado) }}
                                <div v-if="consumo.retorno.dc_valor_a_mais">
                                    <small class="small text-muted">
                                        <i class="fa-solid fa-circle-plus mr-1"></i>
                                        {{ $util.formatMoeda(consumo.retorno.dc_valor_a_mais) }}
                                    </small>
                                </div>
                            </span>
                          </td>
                          <td class="text-right">
                            <span class="text-danger" v-if="viewMode == 'glosas'">{{ $util.formatMoeda(consumo.valor_reapresentado) }}</span>
                            <span class="text-success" v-else>
                              {{ $util.formatMoeda( consumo.valor_total - consumo.retorno.dc_valor_glosa - consumo.retorno.dc_valor_liberado ) }}
                            </span>
                          </td>
                          <td class="text-center" style="width: 80px;">
                            <az-input
                              sizing="sm"
                              type="autocomplete"
                              service="motivos_glosa.index"
                              :optionsName="'motivos_glosa.index.' + fatura.id_operadora"
                              :optionsParm="{ id_operadora: fatura.id_operadora }"
                              optionsMode="aql"
                              optionsDisplay="search"
                              optionsPosition="center"
                              :optionsInitial="
                                consumo.retorno && consumo.retorno.motivo_glosa
                                  ? consumo.retorno.motivo_glosa.in_codigo
                                  : ''
                              "
                              :optionsSync="false"
                              v-if="consumo.selected && viewMode == 'guias'"
                              :required="consumo.retorno.valor_glosa_editar > 0"
                              v-model="consumo.retorno.motivo_glosa">
                              <template v-slot:buttonposb>
                                <div class="input-group-prepend input-group-sm" v-if="consumo.retorno.motivo_glosa">
                                    <button class="btn btn-outline-secondary btn-sm px-1" type="button" data-toggle="tooltip" data-placement="top"
                                        title="Copiar para os demais items." @click="copiar_motivo_glosa(guia.guia, consumo.retorno.motivo_glosa)">
                                        <i class="fas fa-arrows-alt-v"></i>
                                    </button>
                                </div>
                              </template>
                            </az-input>
                            <span v-else-if="consumo.retorno.motivo_glosa">{{ consumo.retorno.motivo_glosa.in_codigo }}</span>
                          </td>
                        </tr>
                        <!-- Justificativa de Acatamento da Glosa -->
                        <tr v-if="consumo.selected && !consumo.retorno.calcular && viewMode == 'glosas' && consumo.acatado_editar" :key="'j' + ig + '-' + ipr + '-' + icx">
                          <td></td>
                          <td colspan="9">
                            <az-input
                              label="Acatar: Jusitificativa"
                              sizing="sm"
                              :compact="true"
                              v-model="consumo.justificativa_editar" />
                          </td>
                        </tr>
                        <tr v-else-if="viewMode == 'glosas' && consumo.dc_valor_glosado && consumo.st_acatar_justificativa" :key="'jg' + ig + '-' + ipr + '-' + icx">
                          <td></td>
                          <td colspan="9">
                            <small>
                              <span class="text-muted">Acatar Jusitificativa:</span>
                              {{ consumo.st_acatar_justificativa }}
                            </small>
                          </td>
                        </tr>
                      </template>
                    </template>
                  </template>
                </template>
                <tr :key="'f' + ig" v-if=" guia.guia.expanded && procSelected(guia.guia.atendimento_procedimento_guias) ">
                  <td colspan="11" class="text-right">
                    <az-submit color="outline-success btn-sm mb-3" @click="movimentar_guia(guia.guia)">Atualizar</az-submit>
                  </td>
                </tr>
                <!-- Fim dos items da guia -->
              </template>
            </tbody>
          </table>

          <div v-else>
            <az-empty-state icon="fas fa-ban" msg="Fatura Cancelada" v-if="fatura.ch_status == 'CA'" />
            <az-empty-state icon="fas fa-file" msg="Nenhum guia vinculada a fatura." v-else />
          </div>

          <pre v-if="1 == 0 && fatura">{{ fatura }}</pre>

          <br />
          <br />

          <!-- SubMenu de Guias -->
          <nav class="navbar fixed-bottom navbar-light bg-light" id="menu-guias" v-if="viewMode == 'guias'">
            <div>
              <button class="btn btn-secondary mr-2" type="button" @click=" fatura = null; $emit('fechar'); ">
                Fechar
              </button>
              <button class="btn btn-outline-secondary mr-2" @click="$util.logAudit('fatura', fatura.id_fatura)" v-if="fatura.id_fatura">
                Log
              </button>
              <span v-if="eh_reembolso" title="Reembolso" class="mr-3 big">
                <i class="fas fa-search-dollar"></i>
              </span>
            </div>
            <div class="mr-3">
              <div class="progress mt-0 mb-1">
                <div class="indeterminate" v-if="$store.state.loading"></div>
                <div class="determinate" v-else></div>
              </div>

              <span class="btn-group dropup ml-1">
                <button class="btn btn-outline-primary btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                    <i class="fa-solid fa-print"></i>
                </button>
                <div class="dropdown-menu">
                    <a class="dropdown-item" href="#" @click.prevent="imprimir_laudos()" v-if="impressao_laudos">Laudos</a>
                    <a class="dropdown-item" href="#" @click.prevent="imprimir_anexos()">Anexos dos Atendimentos</a>
                </div>
              </span>

              <button class="btn btn-sm ml-1" type="button" :class="desabilitar('recalcular') ? 'btn-outline-secondary' : 'btn-dark'"
                v-if="fatura && !fatura.fl_reapresentacao"
                data-toggle="tooltip" data-placement="top" title="Recalcular Guias"
                :disabled="desabilitar('recalcular')" id="recalcular" @click="recalcular()">
                <i class="fas fa-calculator"></i>
              </button>
              <button class="btn btn-sm ml-1" type="button" :class="desabilitar('remover') ? 'btn-outline-secondary' : 'btn-dark'"
                data-toggle="tooltip" data-placement="top" title="Remover da Fatura"
                :disabled="desabilitar('remover')" id="remover" @click="retirar_da_fatura()">
                <i class="fas fa-upload"></i>
              </button>
              <button class="btn btn-sm ml-1" type="button" :class=" desabilitar('pendenciar') ? 'btn-outline-secondary' : 'btn-warning' "
                data-toggle="tooltip" data-placement="top" title="Adicionar Pendência" :disabled="desabilitar('pendenciar')"
                id="pendenciar">
                <i class="fas fa-exclamation-circle"></i>
              </button>
              <button class="btn btn-sm ml-1" type="button" :class=" desabilitar('cancelar-mov') ? 'btn-outline-secondary' : 'btn-danger' "
                data-toggle="tooltip" data-placement="top" title="Cancelar Movimentação" :disabled="desabilitar('cancelar-mov')"
                @click="cancelar_mov()" id="cancelar-mov">
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
              <button class="btn btn-sm ml-1" type="button" :class=" desabilitar('glosar') ? 'btn-outline-secondary' : 'btn-danger' "
                data-toggle="tooltip" data-placement="top" title="Glosar Guia" :disabled="desabilitar('glosar')"
                @click="glosar_guias()" id="glosar">
                <i class="fas fa-ban"></i>
              </button>
              <button class="btn btn-sm ml-1" type="button" :class=" desabilitar('receber') ? 'btn-outline-secondary' : 'btn-primary' "
                data-toggle="tooltip" data-placement="top" title="Atribuir Recebimento"
                :disabled="desabilitar('receber')" @click="receber()"
                id="receber"
              >
                <i class="fas fa-donate"></i>
              </button>
            </div>
          </nav>

          <!-- SubMenu de Análise de Glosa -->
          <nav class="navbar fixed-bottom navbar-light bg-light" id="menu-analise-glosa" v-if="viewMode == 'glosas'">
            <button class="btn btn-secondary" type="button" @click="fatura = null; $emit('fechar');">
              Fechar
            </button>
            <div class="mr-3">
              <button class="btn btn-sm ml-1" type="button" :class=" desabilitar_reap('add_reap') ? 'btn-outline-secondary' : 'btn-dark' "
                data-toggle="tooltip" data-placement="top" title="Adicionar ao Recurso de Glosa" :disabled="desabilitar_reap('add_reap')"
                id="add_reap" name="add_reap" key="add_reap" @click="add_reapresantecao()">
                <i class="fas fa-download"></i>
              </button>
              <button class="btn btn-sm ml-1" type="button" :class=" desabilitar_reap('criar_reap') ? 'btn-outline-secondary' : 'btn-danger' "
                data-toggle="tooltip" data-placement="top" title="Criar Envio de Recurso de Glosa" :disabled="desabilitar_reap('criar_reap')"
                id="criar_reap" key="criar_reap" @click="reapresentar()" >
                <i class="fas fa-folder-plus"></i>
              </button>
              <button class="btn btn-sm ml-1" type="button" :class=" desabilitar_reap('cancelar-analise') ? 'btn-outline-secondary' : 'btn-danger' "
                data-toggle="tooltip" data-placement="top" title="Cancelar Análise" :disabled="desabilitar_reap('cancelar-analise')"
                @click="analisar_glosa('cancelar')" id="cancelar-analise" key="cancelar-analise">
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
              <button class="btn btn-sm ml-1" type="button" :class=" desabilitar_reap('acatar-tudo') ? 'btn-outline-secondary' : 'btn-danger' "
                data-toggle="tooltip" data-placement="top" title="Acatar Tudo" :disabled="desabilitar_reap('acatar-tudo')"
                @click="acatar_justificativa()" id="acatar-tudo" key="acatar-tudo"> <!-- analisar_glosa('acatar') -->
                <i class="fa fa-check" aria-hidden="true"></i>
              </button>
              <button class="btn btn-sm ml-1" type="button" :class=" desabilitar_reap('reap-tudo') ? 'btn-outline-secondary' : 'btn-danger' "
                data-toggle="tooltip" data-placement="top" title="Reapresentar Tudo" v-if="false"
                :disabled="desabilitar_reap('reap-tudo')" @click="analisar_glosa('reapresentar')" id="reap-tudo" key="reap-tudo">
                <i class="fa fa-share" aria-hidden="true"></i>
              </button>
            </div>
          </nav>
        </div>

      </template>

      <!-- Movimentações -->
      <div v-if="viewMode == 'mov'">
        <table class="table bg-white">
          <thead>
            <tr>
              <th>Data</th>
              <th></th>
              <th class="text-right">Recebido</th>
              <th class="text-right">A mais</th>
              <th class="text-right">Total</th>
              <th class="text-right">Glosado</th>
              <th class="text-right">Guias</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, grupo, igx) in datas_retornos">
              <tr :key="igx" v-if="true">
                <td>
                  <span v-if="grupo == '-'">{{ grupo }}</span>
                  <a href="#" class="card-link" @click.prevent="filtrar('M' + $util.getFormatDate(grupo)); filtro_valor = 'T'; viewMode = 'guias';" v-else>
                    {{ $util.getFormatDate(grupo) }}
                  </a>

                  <a href="#" @click.prevent="editar_data_movimentacao(item, grupo)" class="ml-2" title="Editar Data da Movimentação" v-if="!item.identificado">
                    <i class="fa-solid fa-pen"></i>
                  </a>
                </td>
                <td>
                  <button type="button" class="btn btn-sm btn-outline-primary" v-if="grupo != '-' && ( item.recebido > 0 || item.identificado > 0 )"
                    @click="identificar_credito(item, grupo)">
                    Identificar Crédito
                  </button>
                </td>

                <td class="text-right">{{ $util.formatMoeda(item.recebido) }}</td>
                <td class="text-right">{{ $util.formatMoeda(item.a_mais) }}</td>
                <td class="text-right">{{ $util.formatMoeda(item.recebido + ( item.a_mais ? item.a_mais : 0 )) }}
                    <div v-if="item.identificado > 0">
                        <a href="#" @click.prevent="listar_creditos(item, grupo)" class="card-link" data-toggle="tooltip" data-placement="top" title="Crédito Identificado.">
                            <i class="fas fa-check-circle mr-2" 
                                :class="Math.round(parseFloat(item.recebido + ( item.a_mais ? item.a_mais : 0 )) * 100) == Math.round( 100 * ( parseFloat(item.identificado) + parseFloat(item.retido) ) ) ? 'text-success' : 'text-danger'"></i>
                            <small class="text-muted mr-2" v-if="item.retido">
                                ({{ $util.formatMoeda(item.retido) }})
                            </small>
                            <small class="text-muted">
                                {{ $util.formatMoeda(item.identificado) }}
                            </small>
                        </a>
                    </div>
                </td>
                <td class="text-right">{{ $util.formatMoeda(item.glosas) }}</td>
                <td class="text-right">{{ item.guias }}</td>
              </tr>
              <template v-if="false">
                <tr v-for="(guia, igx2) in item.items" :key="igx + '.' + igx2">
                  <td>
                    <i class="fas fa-caret-right mr-2"></i>
                    {{ guia.guia_formatada }}
                    {{ guia }}
                  </td>
                  <td class="text-right">
                    {{ guia.retorno.dc_valor_liberado }}
                  </td>
                  <td class="text-right">{{ guia.retorno.dc_valor_glosa }}</td>
                  <td class="text-right">{{ guia.retorno.dc_valor_a_mais }}</td>
                  <td></td>
                </tr>
              </template>
            </template>
          </tbody>
          <tfoot>
            <tr>
              <th colspan="2">Total</th>
              <th class="text-right">
                {{ $util.formatMoeda( $util.somar(to_array(datas_retornos), "recebido") ) }}
              </th>
              <th class="text-right">
                {{ $util.formatMoeda( $util.somar(to_array(datas_retornos), "a_mais") ) }}
              </th>
              <th class="text-right">
                {{ $util.formatMoeda( $util.somar(to_array(datas_retornos), "recebido") + $util.somar(to_array(datas_retornos), "a_mais") ) }}
              </th>
              <th class="text-right">
                {{ $util.formatMoeda( $util.somar(to_array(datas_retornos), "glosas") ) }}
              </th>
              
              <th class="text-right"></th>
            </tr>
          </tfoot>
        </table>

        <pre v-if="false">{{ retornos }}</pre>

        <pre class="alert alert-warnign" v-if="false">{{ datas_retornos }}</pre>
      </div>

      <br><br><br>

      <!-- Edição de Observação -->
      <div class="modal fade" id="modalFaturaObs" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content" v-if="edicao_obs">
            <div class="modal-header">
              <h5 class="modal-title">Observações</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <az-input type="textarea" rows="10" v-model="edicao_obs.st_observacoes" />

              <template v-if="edicao_obs.operadora.fl_sus">
                <div class="form-row">
                  <div class="col col-12 col-md-6">
                    <az-input
                      label="Orgão de Destino"
                      v-model="edicao_obs.st_sus_orgao" />
                  </div>
                  <div class="col col-12 col-md-3">
                    <az-input
                      label="Orgão"
                      type="select"
                      placeholder="Selecione..."
                      :optionsList="[
                        { id: 'E', search: 'Estadual' },
                        { id: 'M', search: 'Municipal' },
                      ]"
                      optionsData="id"
                      v-model="edicao_obs.st_sus_orgao_tipo" />
                  </div>
                  <div class="col col-12 col-md-3">
                    <az-input
                      label="BPA Folha Inicial"
                      type="number"
                      placeholder="1..."
                      v-model="edicao_obs.in_bpa_folha_inicial" />
                  </div>
                </div>
              </template>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Fechar
              </button>
              <az-submit @click="salvar_observacao()">Atualizar</az-submit>
            </div>
          </div>
        </div>
      </div>

      <!-- Edição de Guia -->

      <guia-edicao ref="edicaoFat" @refresh="abrirFatura(fatura)"></guia-edicao>

      <!-- Análise de Glosa -->

      <div v-if="1 == 0 && viewMode == 'glosas'">Análise de Glosa...</div>

      <!-- Fim -->

      <pre v-if="1 == 0">{{ fatura }}</pre>

      <!-- Modal de Envio de Fatura -->
      <div class="modal fade" id="envioModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" >
        <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
          <div class="modal-content" v-if="envio">
            <div class="modal-header">
              <h5 class="modal-title">Marcar como Enviada</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" v-if="envio">
              <div class="row">
                <div class="col col-12">
                  <az-input
                    type="date"
                    label="Data de Envio"
                    required
                    :validate="validate"
                    rules2="['passado']"
                    v-model="envio.dt_envio"
                  />
                </div>
              </div>
              <div class="row" v-if="fatura && fatura.operadora.parametro_fatura.info_vencimento">
                <div class="col col-12">
                  <az-input
                    type="date"
                    label="Data de Vencimento"
                    required
                    :validate="validate"
                    v-model="envio.dt_vencimento" />
                </div>
              </div>
              <div class="row">
                <div class="col col-12">
                  <az-input
                    label="Protocolo de Entrega"
                    :validate="validate"
                    v-model="envio.st_protocolo_entrega"
                  />
                </div>
              </div>

              <template v-if="fatura.operadora.fl_nota_fiscal">
                <p class="alert alert-warning mt-3">Enviar Nota Fiscal</p>

                <div class="row" v-if="!podeEmietirNotaFiscal">
                  <div class="col col-12">
                    <az-input
                      label="Nota Fiscal"
                      :validate="validate"
                      v-model="envio.st_nota_fiscal"
                    />
                  </div>
                </div>
              </template>

              <template v-if="envio.retencoes && envio.impostos">
                <az-sub-title title="Impostos" />
                <div class="alert alert-info d-flex justify-content-between">
                  <div>Valor da Fatura</div>
                  <div>{{ $util.formatMoeda(envio.dc_valor) }}</div>
                </div>

                <impostos 
                  :impostos="envio.impostos" 
                  :aliquotas="false"
                  :edicao="true"
                  v-model="envio" />
              </template>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
              <az-submit @click="enviar()">Marcar</az-submit>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Nota Fiscal -->
      <div class="modal fade" id="notaFiscalModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Nota Fiscal</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" v-if="nota_fiscal">
              <div class="row">
                <div class="col col-12">
                  <az-input
                    label="Nota Fiscal"
                    placeholder="Informar..."
                    v-model="nota_fiscal.st_nota_fiscal" />
                </div>
              </div>

              <template v-if="fatura && fatura.operadora.parametro_fatura.info_vencimento">
                <div class="row">
                  <div class="col col-12">
                    <az-input
                      label="Envio"
                      type="date"
                      :edicao="false"
                      v-model="nota_fiscal.dt_envio" />
                  </div>
                </div>

                <div class="row">
                  <div class="col col-12">
                    <az-input
                      label="Vencimento"
                      type="date"
                      required
                      v-model="nota_fiscal.dt_vencimento" />
                  </div>
                </div>
              </template>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
              <az-submit @click="salvar_nota_fiscal()">Atualizar</az-submit>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal para Cancelar -->
      <div class="modal fade" id="cancelarModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" >
        <div class="modal-dialog" role="document">
          <div class="modal-content" v-if="cancelar">
            <div class="modal-header">
              <h5 class="modal-title">Cancelar Fatura</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <az-input
                label="Motivo"
                type="textarea"
                v-model="cancelar.st_motivo"
                required
                :validate="validate"
              />
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
              <az-submit color="danger" @click="enviar_cancelamento()">Cancelar Fatura</az-submit>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal para Glosar -->
      <div class="modal fade" id="glosarGuiasModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content" v-if="glosar">
            <div class="modal-header">
              <h5 class="modal-title">Glosar Guias</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <span class="display-4 text-danger mr-2">{{ selecteds.length }} {{ selecteds.length > 1 ? "Guias" : "Guia" }}</span>
                <span class="text-muted">{{ selecteds.length > 1 ? "Selecionadas" : "Selecionada" }}</span>
              </div>
              <div>
                <az-input
                  label="Data"
                  type="date"
                  required
                  :validate="validate"
                  v-model="dt_retorno"
                />
              </div>
              <div>
                <az-input
                  label="Código da Glosa"
                  type="autocomplete"
                  service="motivos_glosa.index"
                  :optionsName="'motivos_glosa.index.' + fatura.id_operadora"
                  :optionsParm="{ id_operadora: fatura.id_operadora }"
                  optionsMode="aql"
                  optionsData="id_motivo_glosa"
                  optionsDisplay="search"
                  :optionsSync="false"
                  required
                  :validate="validate"
                  v-model="glosar.id_motivo_glosa"
                />
              </div>

              <div>
                <div class="mt-3">
                  <az-input
                    type="button-group"
                    :optionsList="[
                      { id: 'T', search: 'Total' },
                      { id: 'X', search: 'Parcial' },
                      { id: 'P', search: 'Procedimento' },
                      { id: 'C', search: 'Mat/Med/Taxa' },
                    ]"
                    optionsData="id"
                    v-model="glosar.escopo" />
                </div>

                <template v-if="glosar.escopo == 'X'">
                  <div class="form-row mt-3">
                    <div class="col col-12 col-md-3">
                      <az-input 
                        icon="fas fa-dollar-sign fa-fw"
                        type="money"
                        required
                        :validate="validate"
                        v-model="glosar.valor" />
                    </div>
                    <div class="col col-12 col-md-9">
                      <az-input 
                        type="checkbox-group"
                        label="Receber valor restante do procedimento."
                        v-model="glosar.receber_complemento" />
                    </div>
                  </div>
                </template>

                <template v-else-if="glosar.escopo == 'P'">
                  <div class="form-row mt-3">
                    <div class="col col-12 col-md-9">
                      <az-input
                        placeholder="Selecione o Procedimento..."
                        icon="fas fa-play fa-fw"
                        type="autocomplete"
                        optionsMode="aql"
                        :optionsName="( $store.state.user.proc_oper ? 'procedimentos.agenda.op.' + fatura.id_operadora : 'procedimentos.agenda' )"
                        :optionsParm="$store.state.user.proc_oper 
                            ? { 
                                id_operadora: fatura.id_operadora, 
                                cc: false, 
                            } 
                            : {
                                cc: false, 
                            }"
                        :optionsSync="false"
                        required
                        :validate="validate"
                        v-model="glosar.procedimento"
                        ref="info_procedimento"
                        :procsigla="true" /> 
                    </div>
                    <div class="col col-12 col-md-3">
                      <az-input 
                        icon="fas fa-dollar-sign fa-fw"
                        type="money"
                        required
                        :validate="validate"
                        v-model="glosar.valor" />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col col-12">
                      <az-input 
                        type="checkbox-group"
                        label="Receber valor restante do procedimento."
                        v-model="glosar.receber_complemento" />
                    </div>
                  </div>
                </template>

                <template v-if="glosar.escopo == 'C'">
                  <div class="form-row mt-3">
                    <div class="col col-12 col-md-9">
                      <az-input
                        placeholder="Selecione o Mat/Med/Taxa..."
                        icon="fas fa-shopping-cart fa-fw"
                        type="autocomplete"
                        optionsMode="aql"
                        optionsName="consumo.index"
                        service="consumo.index"
                        :optionsParm="{ id_operadora: fatura.id_operadora }"
                        required
                        :validate="validate"
                        v-model="glosar.consumo"
                        ref="info_consumo"
                        :procsigla="true" /> 
                    </div>
                    <div class="col col-12 col-md-3">
                      <az-input 
                        icon="fas fa-dollar-sign fa-fw"
                        type="money"
                        required
                        :validate="validate"
                        v-model="glosar.valor" />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col col-12">
                      <az-input 
                        type="checkbox-group"
                        label="Receber valor restante do item."
                        v-model="glosar.receber_complemento" />
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
              <az-submit color="danger" @click="enviar_guias_para_glosar()">Glosar</az-submit>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="imprimirModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Imprimir</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <az-input type="checkbox-group" label="Capa" />
            <az-input type="checkbox-group" label="Lista de Guias Sintético" />
            <az-input type="checkbox-group" label="Lista de Guias Analítico" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <button type="button" class="btn btn-success" @click="imprimirCapaFatura()">Imprimir</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Seleção de Reapresentação -->
    <div class="modal fade" id="selecionarReapresentacaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Selecionar Recurso de Glosa</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="progress mt-0 mb-1">
              <div class="indeterminate" v-if="$store.state.loading"></div>
              <div class="determinate" v-else></div>
            </div>
            <div class="list-group" v-if="fatura && fatura.reapresentacoes">
              <button type="button" class="list-group-item list-group-item-action" v-for="(reap, irp) in fatura.reapresentacoes" :key="irp"
                :disabled="reap.ch_status != 'FA' || $store.state.loading" @click="salvar_add_reapresentacao(reap)">

                {{ $util.getFormatDate(reap.dt_emissao) }}

                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                #{{ reap.id_fatura }}
                <span class="badge ml-1" :class="'badge-' + reap.status_color"
                  data-toggle="tooltip" data-placement="top" :title="reap.status">
                  {{ reap.ch_status }}
                </span>

                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                <span>{{ reap.valor_total.items }} {{ reap.valor_total.items > 1 ? 'Itens' : 'Item' }}</span>

                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                <span>R$ {{ $util.formatMoeda(reap.valor_total.total) }}</span>

              </button>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Movimentação -->
    <div class="modal fade" id="retornoFaturaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Movimentação</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <az-input
              type="date"
              required
              :validate="validate"
              v-model="dt_retorno"
            />

            <az-input
                v-if="pode_valor_a_mais !== null"
                type="checkbox-group"
                :validate="validate"
                label="Confirma recebimento a mais"
                v-model="pode_valor_a_mais" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="mov_guia ? salvar_movimentar_guia() : salvar_receber()">Atualizar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="listarCreditosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Créditos Identificados</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <ul class="list-group" v-if="creditos_ident">
              <li class="list-group-item d-flex justify-content-between">
                <div>Recebimento em: {{ $util.getFormatDate(creditos_ident.data) }}</div>
                <div>{{ $util.formatMoeda(creditos_ident.recebido) }}</div>
              </li>
              <li class="list-group-item d-flex justify-content-between" v-for="(credito, icx) in creditos_ident.item.creditos" :key="icx">
                <div>
                  <div>
                    {{ $util.getFormatDate(credito.baixa.dt_baixa) }}
                    <small class="text-muted ml-2" v-if="credito.baixa.lancamento.categoria">
                      {{ credito.baixa.lancamento.categoria.search }}
                    </small>
                    <small class="text-muted ml-2">
                      #{{ credito.baixa.id_lancamento }}
                    </small>
                  </div>
                  <div>
                    {{ credito.baixa.lancamento.st_descricao }}
                  </div>
                  <div v-if="true">
                    <a href="#" @click.prevent="identificar_nota_fiscal(credito)">
                      <span v-if="credito.id_nota_fiscal_servico">
                        {{ credito.nota ? credito.nota.search : 'NF: ' + credito.id_nota_fiscal_servico }}
                      </span>
                      <span v-else>
                        Identificar Nota Fiscal
                      </span>
                    </a>
                  </div>
                </div>
                <div class="text-right">
                  <div>
                    <small v-if="credito.dc_retencoes" class="mr-2">
                      ({{ $util.formatMoeda(credito.dc_retencoes) }})
                    </small>
                    {{ $util.formatMoeda(credito.dc_valor )}}
                  </div>
                  <small class="text-muted">{{ $util.formatMoeda(credito.baixa.valor_liquido) }}</small>
                </div>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <div>Total:</div>
                <div>
                  <small class="mr-2" v-if="creditos_ident.item.retido">({{ $util.formatMoeda(creditos_ident.item.retido) }})</small>
                  {{ $util.formatMoeda(creditos_ident.item.identificado) }}
                </div>
              </li>
            </ul>
            <pre v-if="1 == 0 && creditos_ident">{{ creditos_ident }}</pre>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Identificação de Créditos -->
    <div class="modal fade" id="identificarCreditosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Identificar Créditos
              <span v-if="creditos">
                <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                {{ $util.getFormatDate(creditos.data) }}
                <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                {{ $util.formatMoeda(creditos.recebido) }}
              </span>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <az-empty-state v-if="!creditos" />
            <template v-else>
              <ul class="list-group">
                <li class="list-group-item d-flex justify-content-between">
                  <div>Recebimento em: {{ $util.getFormatDate(creditos.data) }}</div>
                  <div>{{ $util.formatMoeda(creditos.recebido) }}</div>
                </li>
                <li class="list-group-item p-0">
                  <div class="mt-3 mx-1 form-row">
                    <div class="col col-12 col-md-3">
                      <az-input
                        sizing="sm"
                        type="date"
                        icon="fa-solid fa-greater-than-equal fa-fw"
                        v-model="filtro_data_credito" />
                    </div>
                    <div class="col col-12 col-md-3">
                      <az-input
                        sizing="sm"
                        type="date"
                        icon="fa-solid fa-less-than-equal fa-fw"
                        v-model="filtro_data_ate_credito" />
                    </div>
                    <div class="col col-12 col-md-3">
                      <az-input
                        type="checkbox-group"
                        sizing="sm"
                        :label="'Categoria: ' + fatura.operadora.categoria.search"
                        v-if="fatura && fatura.operadora && fatura.operadora.categoria"
                        v-model="filtro_categoria_credito" />
                      
                      <az-input
                        type="checkbox-group"
                        sizing="sm"
                        label="Categoria"
                        :edicao="false"
                        v-else
                        v-model="filtro_categoria_credito" />
                    </div>
                    <div class="col col-12 col-md-3">
                      <az-input 
                        type="select"
                        sizing="sm"
                        icon="fa fa-building fa-fw"
                        placeholder="Todas as Unidades..."
                        :optionsList="$util.unidades_com_tags(false, true)"
                        optionsData="id_unidade_operacao"
                        v-model="filtro_unidade_credito" />
                    </div>
                  </div>
                  <div class="my-2 mx-1 form-row">
                    <div class="col col-12">
                      <az-input
                        icon="fa fa-search fa-fw"
                        sizing="sm"
                        placeholder="Filtrar..."
                        v-model="filtro_texto_credito" />
                    </div>
                  </div>

                  <table class="table mb-0">
                    <thead>
                      <tr>
                        <th width="5%"></th>
                        <th width="27%">Data</th>
                        <th width="17%" class="text-right">Crédito</th>
                        <th width="17%" class="text-right">Uso</th>
                        <th width="17%" class="text-right">Retenções</th>
                        <th width="17%" class="text-right">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(credito, icx) in filtrar_creditos(creditos.lista)">
                        <tr :key="icx" v-if="true">
                          <td>
                            <input type="checkbox" class="mr-2" v-model="credito.usado">
                          </td>
                          <td>
                            <div>
                              {{ $util.getFormatDate(credito.dt_baixa) }}
                              <small class="text-muted ml-2">#{{ credito.id_lancamento }}</small>
                              <small class="text-muted ml-2" v-if="credito.lancamento.categoria">
                                {{ credito.lancamento.categoria.search }}
                              </small>
                            </div>
                            <div>
                              <small>{{ credito.lancamento.st_descricao }}</small>
                              <small v-if="credito.uso_outras_faturas" class="text-muted ml-2">{{ $util.formatMoeda(credito.valor_liquido) }}</small>
                              <span class="badge badge-light" v-if="credito.lancamento.unidade_operacao && credito.lancamento.unidade_operacao.st_sigla">
                                {{ credito.lancamento.unidade_operacao.st_sigla }}
                              </span>
                            </div>

                            <pre v-if="1 == 0">{{ credito.valor_total }} / {{ total_retencoes(credito) }} / {{ credito.dc_valor_uso }}</pre>
                          </td>
                          <td style="max-width: 120px;">
                            <az-input type="label" :label="$util.formatMoeda(credito.valor_liquido - credito.uso_outras_faturas)" />
                          </td>
                          <td style="max-width: 120px;">
                            <az-input :type="calculando_imposto ? 'number' : 'money'" :edicao="credito.usado" v-model="credito.dc_valor_uso" v-if="!credito.fl_ret_do_total" />
                            <az-input type="label" :edicao="false" :label="$util.formatMoeda(credito.valor_total - total_retencoes(credito))" v-else />
                          </td>
                          <td style="max-width: 120px;">
                            <az-input type="label" :edicao="false" :label="$util.formatMoeda(total_retencoes(credito))">
                              <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="credito.usado && !credito.retencoes.length">
                                  <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-calculator"></i>
                                  </button>
                                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a class="dropdown-item" href="#" @click.prevent="calc_impostos(credito)">A partir do Uso</a>
                                    <a class="dropdown-item" href="#" @click.prevent="calc_impostos(credito, true)">A partir do Total</a>
                                  </div>
                                </div>
                              </template>
                            </az-input>
                          </td>
                          <td style="max-width: 120px;">
                            <az-input type="label" :label="$util.formatMoeda(credito.dc_valor_uso + total_retencoes(credito))" v-if="!credito.fl_ret_do_total" />
                            <az-input :type="calculando_imposto ? 'number' : 'money'" :edicao="credito.usado" v-model="credito.valor_total" v-else />
                          </td>
                        </tr>
                        <template v-if="credito.usado && credito.dc_valor_uso">
                          <tr v-for="(retencao, irx) in lista_retencoes(credito)" :key="'imposto' + icx + '-' + irx">
                            <td>
                              <button type="button" class="btn btn-outline-primary btn-sm" v-if="!irx" @click="incluir_imposto(credito)">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                              </button>
                            </td>
                            <td colspan="3">
                              <az-input
                                sizing="sm"
                                type="select"
                                service="impostos.index"
                                optionsMode="json"
                                optionsData="id"
                                optionsDisplay="search"
                                :optionsList="[
                                  { id: 'PIS', search: 'PIS' },
                                  { id: 'COFINS', search: 'COFINS' },
                                  { id: 'CSLL', search: 'CSLL' },
                                  { id: 'ISS', search: 'ISS' },
                                  { id: 'INSS', search: 'INSS' },
                                  { id: 'IRRF', search: 'IR' },
                                  { id: 'OUTRO', search: 'OUTRO' },
                                ]"
                                required
                                :validate="validate"
                                placeholder="Selecione o Imposto..."
                                v-model="retencao.st_imposto">
                                <template v-slot:button-pre>
                                  <div class="input-group-prepend">
                                    <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="retencao.fl_ativo = false">
                                      <i class="fa fa-minus" aria-hidden="true"></i>
                                    </button>
                                  </div>
                                </template>
                              </az-input>
                            </td>
                            <td>
                              <az-input
                                sizing="sm"
                                type="money"
                                required
                                :validate="validate"
                                v-model="retencao.dc_valor_retido" />
                            </td>
                            <td>
                              <az-input
                                sizing="sm"
                                placeholder="Observação..."
                                :validate="validate"
                                v-model="retencao.st_observacao" />
                            </td>
                          </tr>
                        </template>
                      </template>
                    </tbody>
                    <tfoot>
                      <tr :class="validar_creditos() ? 'table-success' : 'table-danger'">
                        <th colspan="2">Total</th>
                        <th class="text-right">
                          {{ $util.formatMoeda(totalizar(creditos.lista, 'valor_liquido') - totalizar(creditos.lista, 'uso_outras_faturas')) }}
                        </th>
                        <th class="text-right">
                          {{ $util.formatMoeda(totalizar_uso()) }}
                        </th>
                        <th class="text-right">
                          {{ $util.formatMoeda(totalizar_credito_retencoes()) }}
                        </th>
                        <th class="text-right">
                          {{ $util.formatMoeda(totalizar_total()) }}
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                </li>
                <template v-if="1==0">
                  <li class="list-group-item d-flex justify-content-between" v-for="(credito, icx) in creditos.lista" :key="icx">
                    <div>
                      <div>
                        <input type="checkbox" class="mr-2" v-model="credito.usado">
                        {{ $util.getFormatDate(credito.dt_baixa) }}
                        <small class="text-muted ml-2">#{{ credito.id_lancamento }}</small>
                        <small class="text-muted ml-2">
                          {{ credito.lancamento.categoria.search }}
                        </small>
                      </div>
                      <div>
                        <small>{{ credito.lancamento.st_descricao }}</small>
                        <small v-if="credito.uso_outras_faturas" class="text-muted ml-2">{{ $util.formatMoeda(credito.valor_liquido) }}</small>
                      </div>
                    </div>
                    <div class="text-right">
                      {{ $util.formatMoeda(credito.valor_liquido - credito.uso_outras_faturas) }}
                      <div style="max-width: 120px;">
                        <az-input type="money" v-if="credito.usado" v-model="credito.dc_valor_uso" />
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item d-flex justify-content-between"
                    :class="validar_creditos() ? 'list-group-item-success' : 'list-group-item-danger'">
                    <div>Total:</div>
                    <div>
                      {{ $util.formatMoeda(totalizar(creditos.lista, 'dc_valor_uso')) }}
                    </div>
                  </li>
                </template>
              </ul>

                <div class="alert alert-secondary d-flex justify-content-between mt-3" v-if="!eh_reembolso">
                    <div>
                        <span v-if="!block_filtro_credito">São listados os créditos registrados entre a data de envio da fatura e a data do recebimento.</span>
                        <s v-else>São listados os créditos registrados entre a data de envio da fatura e a data do recebimento.</s>
                    </div>
                    <div>
                        <a href="#" @click.prevent="block_filtro_credito = !block_filtro_credito; identificar_credito(creditos.item, creditos.data, true)" class="card-link">
                            {{ block_filtro_credito ? 'Filtrar' : 'Não Filtrar' }}
                        </a>

                        <a href="#" @click.prevent="identificar_credito(creditos.item, creditos.data, true)" class="card-link ml-3" v-if="block_filtro_credito">
                            <i class="fa-solid fa-arrows-rotate"></i>
                        </a>
                    </div>
                </div>

                <div class="alert alert-secondary d-flex justify-content-between mt-3" v-if="!eh_reembolso">
                    <div>
                        <span v-if="!block_filtro_credito_operadora">São listados os créditos registrados para essa operadora, ou que tenham o mesmo registro na ANS.</span>
                        <s v-else>São listados os créditos registrados para essa operadora, ou que tenham o mesmo registro na ANS.</s>
                    </div>
                    <div>
                        <a href="#" @click.prevent="block_filtro_credito_operadora = !block_filtro_credito_operadora; identificar_credito(creditos.item, creditos.data, true)" class="card-link">
                            {{ block_filtro_credito_operadora ? 'Filtrar' : 'Não Filtrar' }}
                        </a>

                        <a href="#" @click.prevent="identificar_credito(creditos.item, creditos.data, true)" class="card-link ml-3" v-if="block_filtro_credito_operadora">
                            <i class="fa-solid fa-arrows-rotate"></i>
                        </a>
                    </div>
                </div>

                <!-- TODO: Listar as notas emitidas com data posterior ao envio da fatura -->
                <!-- Listar as Notas da Operadora que foram emitidas posteriores a data de envio da fatura e tem saldo. -->
                <!-- Não pode ser uma vinculada a fatura -->
                <!-- E ter saldo (valor da nota > créditos identificados) -->
                <az-input
                  v-if="credito_nfs && credito_nfs.length > 0 && podeEmietirNotaFiscal"
                  style="width: 60%"
                  label="Selecione a Nota Fiscal referente ao crédito"
                  type="select"
                  :optionsList="credito_nfs"
                  optionsData="id_nota_fiscal_servico"
                  optionsDisplay="search"
                  :validate="validate"
                  v-model="credito_nf"
                />
            </template>

            <pre v-if="1 == 0">{{ fatura }}</pre>
          </div>
          <div class="modal-footer justify-content-between">
            <span class="float-left" v-if="creditos">
              Selecionado: {{ $util.formatMoeda(totalizar_credito_retencoes() + totalizar(creditos.lista, 'dc_valor_uso')) }}
              <i class="fa fa-check-circle text-success ml-2" aria-hidden="true" v-if="validar_creditos()"></i>
            </span>
            <span>
              <button type="button" class="btn btn-primary mr-2" @click="listar_guias_do_credito(creditos.data)" v-if="creditos && creditos.item && creditos.item.identificado > 0">Listar Guias</button>
              <az-submit color="danger mr-2" v-if="creditos && creditos.item && creditos.item.identificado > 0" @click="remover_identificacao_credito()">Remover</az-submit>
              <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">Fechar</button>
              <az-submit @click="atualizar_credito()">Atualizar</az-submit>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="protocoloGuiaReapModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="protocolo_recurso">
          <div class="modal-header">
            <h5 class="modal-title">Protocolo</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <az-input
              label="Número do Protocolo de Recurso de Glosa"
              v-model="protocolo_recurso.st_protocolo_recurso" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="salvar_protocolo_recurso()">Atualizar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Edição do Protocolo -->
    <div class="modal fade" id="edicaoProtocoloModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="edicao_protocolo">
          <div class="modal-header">
            <h5 class="modal-title">Editar Protocolo</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <az-input
                label="Protocolo de Entrega"
                :validate="validate"
                v-model="edicao_protocolo.st_protocolo_entrega" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="salvar_edicao_protocolo()">Atualizar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Nota Fiscal Geração -->
    <nota-fiscal-geracao id="notaFsicalGeracao" ref="notaFiscalGeracaoRef" @refresh="abrirFatura(fatura, true, true)" @refresh_gerar="abrirFatura(fatura, true)"></nota-fiscal-geracao>

    <!-- Capa Fatura HtmlReport -->
    <div v-if="imprimindo_capa">
      <HTMLReport
        ref="htmlReportRef"
        id="printCapaFatura"
        :logo_url="logo_url"
        :header="true"
        :id_unidade_operacao="unidadeOperacaoPrimeiraGuia"
        v-show="false"
        :parms="capa_parms"
        v-if="fatura && fatura.operadora && fatura.operadora.empresa"
      >
        <div>
          <br />
          <br />
          <br />
          <br />
          <br />
          <p v-if="fatura.fl_reapresentacao">
            Segue recurso de glosa nº
            <strong>{{ fatura.id_fatura }}</strong> (ref. fatura nº <strong>{{ fatura.id_fatura_original }}</strong>) com seus respectivos
            documentos anexo, correspondentes aos serviços médicos prestados à
            operadora abaixo citada:
          </p>
          <p v-else>
            Segue fatura nº
            <strong>{{ fatura.id_fatura }}</strong> com seus respectivos
            documentos anexo, correspondentes aos serviços médicos prestados à
            operadora abaixo citada:
          </p>
          <br />
          <p>
            <strong
              >{{ pegar_nome_capa() }} - CNPJ:
              {{
                this.$util.formatMask(pegar_cnpj_capa())
              }}</strong
            >
          </p>
          <p>
            Endereço: {{pegar_endereco_capa()}}
          </p>
          <p>
            Período: <strong>De {{$util.getFormatDate(fatura.dt_inicio )}} até {{$util.getFormatDate(fatura.dt_fim)}}</strong>
          </p>
          <p>
            Valor Total da Fatura:
            <strong>{{
              this.$util.formatMoeda(fatura.valor_total.total)
            }}</strong>
          </p>
          <br />

          <p>
            Protocolo:
            <strong v-if="fatura.fatura_envio">{{
              fatura.fatura_envio.st_protocolo_entrega
            }}</strong>
          </p>
          <br />
          <p v-if="fatura.fl_reapresentacao && fatura.fatura_envio">
            Vencimento:
            <strong>{{
              $util.getFormatDate(fatura.fatura_envio.dt_vencimento)
            }}</strong>
          </p>

          <br />
          <br />
          <p>{{ assinaturaReport() }}</p>
        </div>
      </HTMLReport>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="logExportacaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Exportação</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Paciente</th>
                  <th>Campo</th>
                  <th>Valor</th>
                  <th>Mensagem</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(log, imx) in log_exportacao" :key="imx" class="small">
                  <td>{{ log.paciente }}</td>
                  <td>{{ log.campo }}</td>
                  <td>{{ log.valor }}</td>
                  <td>{{ log.msg }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="vencimentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Vencimento</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <az-input
              label="Vencimento"
              type="date"
              required
              :validate="validate"
              v-model="edicao_vencimento">
              <template v-slot:buttonposb>
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon2" v-if="edicao_vencimento">
                    {{ $util.getFormatDate(edicao_vencimento, 'dddd') }}
                  </span>
                  <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="acrescentar_dias = !acrescentar_dias">
                    <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                  </button>
                </div>
              </template>
            </az-input>
            
            <div v-if="fatura">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Imposto</th>
                            <th>Aliquota</th>
                            <th>Valor Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(campo, icx) in fatura.retencoes" :key="icx">
                            <td>
                                {{ campo.imposto.search }}
                            </td>
                            <td>
                                {{ $util.formatNumber(campo.dc_aliquota, 2) + "%" }}
                            </td>
                            <td>
                                {{ "R$ " + $util.formatNumber(campo.dc_valor, 2) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <az-input
              icon="fa fa-plus"
              type="number"
              v-if="acrescentar_dias"
              v-model="dias_somar_vencimento">
              <template v-slot:buttonposb>
                <div class="input-group-append">
                  <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="ajustar_vencimento()">
                    <i class="fas fa-calculator fa-fw"></i>
                  </button>
                </div>
              </template>
            </az-input>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="salvar_vencimento()">Atualizar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="emissaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Emissão</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <az-input
              label="Emissão"
              type="date"
              required
              :validate="validate"
              v-model="edicao_emissao" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="salvar_emissao()">Atualizar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="gerarArquivoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content" v-if="modal_gerar_arquivo">
          <div class="modal-header">
            <h5 class="modal-title">Gerar Arquivo</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" >
            <div class="container" v-if="fatura && exibir">
                <template v-if="fatura.fl_reapresentacao">
                    <div class="row">
                      <div class="input-group col col-6">
                        <div class="input-group-prepend">
                          <div class="input-group-text">
                            <input
                              type="radio"
                              aria-label="Radio button for following text input"
                              value="R"
                              v-model="arq_fatura.reapresentacao"
                            />
                          </div>
                        </div>
                        <label class="form-control">Reapresentação</label>
                      </div>

                      <div class="input-group col col-6">
                        <div class="input-group-prepend">
                          <div class="input-group-text">
                            <input
                              type="radio"
                              aria-label="Radio button for following text input"
                              value="G"
                              v-model="arq_fatura.reapresentacao"
                            />
                          </div>
                        </div>
                        <label class="form-control">Recurso de Glosa</label>
                      </div>
                    </div>

                    <template v-if="arq_fatura.reapresentacao == 'G'">
                        <az-sub-title class="mt-3" title="Tipo do Recurso de Glosa" />
                        <div class="row">

                          <div class="input-group col col-4">
                            <div class="input-group-prepend">
                              <div class="input-group-text">
                                <input
                                  type="radio"
                                  aria-label="Radio button for following text input"
                                  value="P"
                                  v-model="arq_fatura.recurso_tipo"
                                />
                              </div>
                            </div>
                            <label class="form-control">Padrão</label>
                          </div>

                          <div class="input-group col col-4">
                            <div class="input-group-prepend">
                              <div class="input-group-text">
                                <input
                                  type="radio"
                                  aria-label="Radio button for following text input"
                                  value="I"
                                  v-model="arq_fatura.recurso_tipo"
                                />
                              </div>
                            </div>
                            <label class="form-control">Por Item</label>
                          </div>

                          <div class="input-group col col-4">
                            <div class="input-group-prepend">
                              <div class="input-group-text">
                                <input
                                  type="radio"
                                  aria-label="Radio button for following text input"
                                  value="G"
                                  v-model="arq_fatura.recurso_tipo"
                                />
                              </div>
                            </div>
                            <label class="form-control">Guia completa</label>
                          </div>
                        </div>

                        <div>
                            <div class="alert alert-info mt-3" v-if="arq_fatura.recurso_tipo == 'P'">
                                <h5 class="alert-heading">Padrão</h5>
                                <p>
                                    Nesta opção, o sistema decide automaticamente se o recurso será gerado 
                                    <strong>por item</strong> ou <strong>para a guia completa</strong>, com base no status da guia. 
                                    Isso segue o padrão TISS, garantindo que o tipo de recurso mais adequado seja aplicado.
                                </p>
                            </div>

                            <div class="alert alert-info mt-3" v-else-if="arq_fatura.recurso_tipo == 'I'">
                                <h5 class="alert-heading">Por Item</h5>
                                <p>
                                    Nesta opção, o recurso será gerado individualmente para <strong>cada item</strong> da guia. 
                                    Isso permite contestar detalhadamente cada procedimento glosado, com justificativa e valor próprios.
                                    Ideal quando apenas alguns itens da guia foram glosados.
                                </p>
                            </div>

                            <div class="alert alert-info mt-3" v-else-if="arq_fatura.recurso_tipo == 'G'">
                                <h5 class="alert-heading">Guia Completa</h5>
                                <p>
                                    Nesta opção, o recurso é gerado para a guia inteira, abrangendo todos os itens em uma única contestação. 
                                    É útil quando a glosa atinge a guia completa ou quando deseja enviar um recurso de forma consolidada, sem detalhar item a item.
                                </p>
                            </div>
                        </div>

                    </template>

                </template>

                <template v-else>
                    <az-sub-title class="mt-1" title="Tipo do Arquivo" />
                    <div class="row">
                        <div class="input-group col col-6">
                            <div class="input-group-prepend">
                              <div class="input-group-text">
                                <input
                                  type="radio"
                                  aria-label="Radio button for following text input"
                                  value="Z"
                                  v-model="arq_fatura.tipo_arquivo"
                                />
                              </div>
                            </div>
                            <label class="form-control">ZIP</label>
                        </div>

                        <div class="input-group col col-6">
                            <div class="input-group-prepend">
                              <div class="input-group-text">
                                <input
                                  type="radio"
                                  aria-label="Radio button for following text input"
                                  value="X"
                                  v-model="arq_fatura.tipo_arquivo"
                                />
                              </div>
                            </div>
                            <label class="form-control">XML</label>
                        </div>
                    </div>

                    <!-- Tipos de guias -->
                    <az-sub-title class="mt-1" title="Tipos de guia" />
                    <div class="d-flex flex-column">
                        <template v-if="arq_fatura.tipo_arquivo == 'Z'">
                            <div class="input-group mt-1" v-if="possuiGuiaTipo('S')">
                                <div class="input-group-prepend">
                                  <div class="input-group-text">
                                    <input
                                      type="checkbox"
                                      aria-label="Radio button for following text input"
                                      v-model="arq_fatura.guia.sadt"
                                    />
                                  </div>
                                </div>
                                <label class="form-control">SP/SADT</label>
                            </div>

                            <div class="input-group mt-1" v-if="possuiGuiaTipo('C')">
                                <div class="input-group-prepend">
                                  <div class="input-group-text">
                                    <input
                                      type="checkbox"
                                      aria-label="Radio button for following text input"
                                      v-model="arq_fatura.guia.consulta"
                                    />
                                  </div>
                                </div>
                                <label class="form-control">Consulta</label>
                            </div>

                            <div class="input-group mt-1" v-if="possuiGuiaTipo('H')">
                                <div class="input-group-prepend">
                                  <div class="input-group-text">
                                    <input
                                      type="checkbox"
                                      aria-label="Radio button for following text input"
                                      v-model="arq_fatura.guia.honorario"
                                    />
                                  </div>
                                </div>
                                <label class="form-control">Honorário Individual</label>
                            </div>

                            <div class="input-group mt-1" v-if="possuiGuiaTipo('R')">
                                <div class="input-group-prepend">
                                  <div class="input-group-text">
                                    <input
                                      type="checkbox"
                                      aria-label="Radio button for following text input"
                                      v-model="arq_fatura.guia.internacao"
                                    />
                                  </div>
                                </div>
                                <label class="form-control">Resumo de Internação</label>
                            </div>

                            <div class="input-group mt-1" v-if="possuiGuiaTipo('D')">
                                <div class="input-group-prepend">
                                  <div class="input-group-text">
                                    <input
                                      type="checkbox"
                                      aria-label="Radio button for following text input"
                                      v-model="arq_fatura.guia.odonto"
                                    />
                                  </div>
                                </div>
                                <label class="form-control">Odontologia</label>
                            </div>
                        </template>
                        <!-- XML -->
                        <template v-else>
                            <div class="input-group mt-1" v-if="possuiGuiaTipo('S')">
                                <div class="input-group-prepend">
                                  <div class="input-group-text">
                                    <input
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                      value="S"
                                      v-model="arq_fatura.tipo_guia"
                                      :disabled="possuiMaisDe100('S')"
                                    />
                                  </div>
                                </div>
                                <label class="form-control">SP/SADT <span class="text-danger">{{possuiMaisDe100('S') ? '- Existem mais de 100 guias SP/SADT, utilize o tipo de arquivo ZIP' : ''}}</span></label>
                            </div>

                            <div class="input-group mt-1" v-if="possuiGuiaTipo('C')">
                                <div class="input-group-prepend">
                                  <div class="input-group-text">
                                    <input
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                      value="C"
                                      v-model="arq_fatura.tipo_guia"
                                      :disabled="possuiMaisDe100('C')"
                                    />
                                  </div>
                                </div>
                                <label class="form-control">Consulta <span class="text-danger">{{possuiMaisDe100('C') ? '- Existem mais de 100 guias de Consulta, utilize o tipo de arquivo ZIP' : ''}}</span></label>
                            </div>

                            <div class="input-group mt-1" v-if="possuiGuiaTipo('H')">
                                <div class="input-group-prepend">
                                  <div class="input-group-text">
                                    <input
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                      value="H"
                                      v-model="arq_fatura.tipo_guia"
                                      :disabled="possuiMaisDe100('H')"
                                    />
                                  </div>
                                </div>
                                <label class="form-control">Honorário Individual <span class="text-danger">{{possuiMaisDe100('H') ? '- Existem mais de 100 guias de Honorário Individual, utilize o tipo de arquivo ZIP' : ''}}</span></label>
                            </div>

                            <div class="input-group mt-1" v-if="possuiGuiaTipo('R')">
                                <div class="input-group-prepend">
                                  <div class="input-group-text">
                                    <input
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                      value="R"
                                      v-model="arq_fatura.tipo_guia"
                                      :disabled="possuiMaisDe100('R')"
                                    />
                                  </div>
                                </div>
                                <label class="form-control">Resumo de Internação <span class="text-danger">{{possuiMaisDe100('H') ? '- Existem mais de 100 guias de Resumo de Internação, utilize o tipo de arquivo ZIP' : ''}}</span></label>
                            </div>

                            <div class="input-group mt-1" v-if="possuiGuiaTipo('D')">
                                <div class="input-group-prepend">
                                  <div class="input-group-text">
                                    <input
                                      type="radio"
                                      aria-label="Radio button for following text input"
                                      value="R"
                                      v-model="arq_fatura.tipo_guia"
                                      :disabled="possuiMaisDe100('D')"
                                    />
                                  </div>
                                </div>
                                <label class="form-control">Odontologia <span class="text-danger">{{possuiMaisDe100('H') ? '- Existem mais de 100 guias de Odontologia, utilize o tipo de arquivo ZIP' : ''}}</span></label>
                            </div>
                        </template>
                    </div>

                    <!-- Ordenação -->
                    <az-sub-title class="mt-1" title="Ordenar por" />
                    <div class="row">
                        <div class="input-group col col-6">
                            <div class="input-group-prepend">
                              <div class="input-group-text">
                                <input
                                  type="radio"
                                  aria-label="Radio button for following text input"
                                  value="P"
                                  v-model="arq_fatura.ordem"
                                />
                              </div>
                            </div>
                            <label class="form-control">Nome do Paciente</label>
                        </div>

                        <div class="input-group col col-6">
                            <div class="input-group-prepend">
                              <div class="input-group-text">
                                <input
                                  type="radio"
                                  aria-label="Radio button for following text input"
                                  value="N"
                                  v-model="arq_fatura.ordem"
                                />
                              </div>
                            </div>
                            <label class="form-control">Número da guia</label>
                        </div>
                    </div>

                    <!-- Outras opções -->
                    <az-sub-title class="mt-1" title="Opções" />
                    <div class="row">
                        <div class="input-group col col-6">
                            <div class="input-group-prepend">
                              <div class="input-group-text">
                                <input
                                  type="checkbox"
                                  aria-label="Radio button for following text input"
                                  value="P"
                                  v-model="arq_fatura.selecionadas"
                                />
                              </div>
                            </div>
                            <label class="form-control">Somente guias selecionadas</label>
                        </div>
                    </div>
                </template>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="atualizar_arquivo_fatura()">Gerar Arquivo</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal SIAD -->
    <div class="modal fade" id="integrarSiadModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">SIAD / Guias</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <az-empty-state v-if="!lista_guias_siad || !lista_guias_siad.length" title="Nenhuma guia identificada." />

            <template v-else>

              <div class="alert alert-info">
                {{ lista_guias_siad.filter(item => item.arquivos.length).length }} Guia(s) com Arquivo Anexado / {{ lista_guias_siad.length }} Total de Guia(s) 
              </div>

              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Atendimento</th>
                    <th>Guia</th>
                    <th>Paciente</th>
                    <th>Médico</th>
                    <th>Arquivos</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(guia, igx) in lista_guias_siad" :key="igx">
                    <td>
                      <a href="#" @click.prevent="abrirAtendimento(guia.id_atendimento)" class="card-link">
                        #{{ guia.id_atendimento }}
                      </a>
                    </td>
                    <td>{{ guia.numero }}</td>
                    <td>{{ guia.paciente.st_nome }}</td>
                    <td>{{ guia.medico.st_nome_exibicao }}</td>
                    <td>
                      <div v-for="(arquivo, iax) in guia.arquivos" :key="iax">
                        <a :href="arquivo.arquivo.temporary_url" class="card-link" target="_blank">{{ arquivo.arquivo.st_titulo }}</a>
                        <span class="badge badge-dark ml-1" v-if="arquivo.arquivo.tipo">
                          {{ arquivo.arquivo.tipo.st_sigla ? arquivo.arquivo.tipo.st_sigla : arquivo.arquivo.tipo.st_descricao }}
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <az-submit @click="exportar_siad()" v-if="lista_guias_siad && lista_guias_siad.length">Enviar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Acatar Justificativa -->
    <div class="modal fade" id="acatarGuiasJustificativa" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Acatar Glosa</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <az-input
              label="Justificativa"
              :validate="validate"
              v-model="texto_acatar_justificativa" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <az-submit @click="analisar_glosa('acatar')">Confirmar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Dispatch -->
    <az-dispatch ref="dispatchModal" :titulo="dispatch_titulo" @refresh="refresh_movimentar" @refreshAxios="refresh_arquivo_fatura" />

    <!-- Log -->
    <log-integracao ref="logint" />

    <!-- Identificar Nota Fiscal de Crédito -->
    <identificar-nota-fiscal-credito ref="ident_nf" @refresh="abrirFatura(fatura, true)" />

    <!-- Registrar Contatos -->
    <registrar-contatos 
        titulo="Fatura"
        :lista_status="lista_status ? lista_status.filter(item => item.id_contato_status != 'R') : []" 
        ref="regcontatos" 
        @refresh="abrirFatura(fatura, true)"></registrar-contatos>

    <!-- Ver Datas Glosa -->
    <ver-retorno-datas-glosa ref="retorno_datas" /> 

    <!-- Pacotes -->
    <historico-pacotes-paciente-modal 
            ref="historico_fatura_pacotes" 
            :paciente="info_pacote ? info_pacote.paciente : null"
            :id_atendimento="info_pacote ? info_pacote.id_atendimento : null" />

    <!-- Editar Contrato Guias -->
    <editar-contrato-guias ref="editar_contrato_guias" @refresh="abrirFatura(fatura, true)" />

    <!-- Imprimir Anexos -->
    <guias-imprimir-anexos ref="imprimir_anexos" />

    <!-- Editar Data Movimentação -->
    <editar-data-mov ref="edit_data_mov" :id_fatura="fatura ? fatura.id_fatura : null" @refresh="abrirFatura(fatura, true)" />

  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import * as moment from "moment";
import AzBreakTitle from "../../util/AzBreakTitle.vue";
import AzSubmit from "../../util/AzSubmit.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import AzEmptyState from "../../util/AzEmptyState.vue";
import GuiaEdicao from "./GuiaEdicao.vue";
import HTMLReport from "../../../components/relatorios/HTMLReport";
import RelatoriosLinkados from "../../relatorios/shared/RelatoriosLinkados.vue";
import SiadBatchProgress from "./SiadBatchProgress.vue";
import TableTh from "../../shared/table/TableTh.vue";
import AzFileUpload from "../../util/AzFileUpload.vue";
import NotaFiscalGeracao from "../financeiro/NotaFiscalGeracao.vue";
import AzDispatch from "../../util/AzDispatch.vue";
import AzSubTitle from '../../util/AzSubTitle.vue';
import LogIntegracao from '../../shared/audit/LogIntegracao.vue';
import IdentificarNotaFiscalCredito from './IdentificarNotaFiscalCredito.vue';
import Impostos from '../financeiro/Impostos.vue';
import RegistrarContatos from '../../shared/RegistrarContatos.vue';
import VerRetornoDatasGlosa from './VerRetornoDatasGlosa.vue';
import HistoricoPacotesPacienteModal from '../../shared/HistoricoPacotesPacienteModal.vue';
import EditarContratoGuias from './EditarContratoGuias.vue';
import GuiasImprimirAnexos from './GuiasImprimirAnexos.vue';
import EditarDataMov from './EditarDataMov.vue';


export default {
  data() {
    return {
      guias: null,
      fatura: null,
      exibir: false,
      selectAll: false,
      validate: false,
      envio: null,
      cancelar: null,
      glosar: null,
      unidade: null,
      viewMode: "guias",
      ordem: "",
      search: "",
      dt_retorno: this.$util.hoje(),
      mov_guia: null,
      nota_fiscal: "",
      justificativa: {
        texto: "",
        item: null,
      },
      creditos: null,
      creditos_ident: null,
      protocolo_recurso: null,
      edicao_obs: null,
      filtro_valor: "T",
      dispatch_titulo: "Movimentando guias...",
      log_exportacao: [],
      edicao_vencimento: "",
      filtro_data_credito: "",
      filtro_data_ate_credito: "", 
      filtro_texto_credito: "",
      filtro_categoria_credito: true, 
      filtro_unidade_credito: "", 
      edicao_emissao: null, 
      edicao_protocolo: null, 
      acrescentar_dias: false, 
      dias_somar_vencimento: 30, 
      credito_nfs: null,
      credito_nf: null,
      arq_fatura: {
        reapresentacao: "R",
        guia: {
            sadt: false,
            consulta: false,
            honorario: false,
            internacao: false,
            odonto: false,
        },
        tipo_guia: "S",
        tipo_arquivo: "Z",
        ordem: "P",
      },
      integracao_siad: false,
      integracao_promedsys: false,
      integracao_ipe: false,
      lista_guias_siad: null,

      calculando_imposto: false, 
      imprimindo_capa: false, 
      texto_acatar_justificativa: "", 
      view_motivo_glosa: false, 
      block_filtro_credito: false, 
      block_filtro_credito_operadora: false, 

      modal_gerar_arquivo: false, 
      pode_valor_a_mais: null, 

      lista_status: null, 
      edicao_contato: null, 

      id_contrato_operadora_selec: null, 
      exibir_protocolo: false, 
      info_pacote: null,

      impressao_laudos: false, 
      
    };
  },

  components: {
    AzBreakTitle,
    AzSubmit,
    AzInput,
    AzEmptyState,
    GuiaEdicao,
    HTMLReport,
    RelatoriosLinkados,
    SiadBatchProgress,
    TableTh,
    AzFileUpload,
    NotaFiscalGeracao,
    AzDispatch,
    AzSubTitle,
    LogIntegracao,
    IdentificarNotaFiscalCredito, 
    Impostos, 
    RegistrarContatos, 
    VerRetornoDatasGlosa, 
    HistoricoPacotesPacienteModal, 
    EditarContratoGuias, 
    GuiasImprimirAnexos, 
    EditarDataMov, 
  },

  watch: {
    viewMode: function() {
      $('[data-toggle="tooltip"]').tooltip();
    }
  },

  computed: {
    lista_protocolos: function() { 
        if ( !this.fatura || !this.fatura.guia_faturas || !this.fatura.guia_faturas.length ) {
            return;
        }

        if ( !this.exibir_protocolo ) { 
            return; 
        }

        let lista = this.fatura.guia_faturas.filter(guia => guia.guia && guia.guia.guia_recebimentos && guia.guia.guia_recebimentos.length);

        if ( !lista || !lista.length ) {
            return;
        }

        return _.groupBy(
            lista, 
            guia => guia.guia.guia_recebimentos[0].protocolo_id
        );
    },

    texto_contratos: function() { 
        if ( !this.fatura || !this.fatura.contratos || !this.fatura.contratos.length ) {
            return "";
        }

        return this.fatura.contratos.map(c => c.st_descricao_arquivo_contrato).join(', ');
    },

    capa_parms: function() { 
      let nome = _.get(this.fatura, 'guia_fatura.guia.contrato_operadora.st_nome_contratado');

      if ( !nome )
        return null; 

      return { 
        nome_contratado: _.get(this.fatura, 'guia_fatura.guia.contrato_operadora.st_nome_contratado')
      };
    },

    logo_url () {
      let unid = _.get(this.fatura, 'guia_fatura.guia.contrato_operadora.unidade_reembolso_nf');

      if ( !unid ) { 
        unid = _.get(this.fatura, 'guia_fatura.guia.atendimento.marcacao.unidade_operacao');
      }

      if ( !unid ) { 
        unid = _.get(this.fatura, 'guia_fatura.guia.atendimento.unidade_operacao');
      }

      return _.get(unid, 'logo.arquivo.temporary_url');
    },

    unidadeOperacaoPrimeiraGuia: function() {
        if( this.fatura
            && this.fatura.guia_fatura
            && this.fatura.guia_fatura.guia
            && this.fatura.guia_fatura.guia.atendimento
            && this.fatura.guia_fatura.guia.atendimento.unidade_operacao
        ) {

          let id_unid_contrato = _.get(this.fatura, 'guia_fatura.guia.contrato_operadora.id_unidade_operacao_reembolso_nf');

            return id_unid_contrato ? id_unid_contrato : this.fatura.guia_fatura.guia.atendimento.unidade_operacao.id_unidade_operacao;

        }

        return null;
    },

    lista_relatorios_linkados_outros: function () { 
      let lista = [];

      lista.push({ title: 'Capa de Fatura', callback: this.imprimirCapaFatura });

      if ( this.fatura && this.fatura.operadora ) { 
        // && this.fatura.operadora.fl_sus 
        lista.push({ title: 'Espelho de Fatura / SUS', callback: this.imprimirEspelho });
      }

      return lista;
    },

    eh_reembolso: function() { 
      if ( !this.fatura ) { 
        return false;
      }

      return this.fatura.guia_faturas.find(gf => gf.guia && gf.guia.atendimento && gf.guia.atendimento.fl_reembolso);
    },

    totais_guias: function() {

      let perc_recebido = 0;
      let perc_glosado = 0;
      let perc_a_receber = 0;

      if ( this.viewMode == 'glosas' ) {

        if ( Math.round(this.valor_total.glosado) > 0 ) {
          perc_glosado   = Math.round( ( this.valor_total.recebido / this.valor_total.glosado ) * 100 );
          perc_recebido  = Math.round( ( this.valor_total.a_receber / this.valor_total.glosado ) * 100 );
          perc_a_receber = ( 100 - perc_recebido - perc_glosado ) > 0 ? 100 - perc_recebido - perc_glosado : 0;
        }

      } else {

        if ( Math.round(this.valor_total.total) > 0 ) {
          perc_recebido  = Math.round( ( this.valor_total.recebido / this.valor_total.total ) * 100 );
          perc_glosado   = Math.round( ( this.valor_total.glosado / this.valor_total.total ) * 100 );
          perc_a_receber = ( 100 - perc_recebido - perc_glosado ) > 0 ? 100 - perc_recebido - perc_glosado : 0;
        }

      }

      return {
        perc_recebido: perc_recebido,
        perc_glosado: perc_glosado,
        perc_a_receber: perc_a_receber,
      };

    },

    retornos: function() {
      if (!this.fatura) return [];

      if ( this.fatura.fl_reapresentacao ) {
        return [];
      }

      return _.flatMap(
        this.fatura.guia_faturas,
        guia_fatura => { 
            if ( guia_fatura.guia.resumido == 'S' ) { 
                console.log('guia resumida', guia_fatura.guia);
                return [
                    { 
                        id_guia: guia_fatura.guia.id_guia,
                        retorno: { 
                            id_guia: guia_fatura.guia.id_guia,
                            dt_retorno: guia_fatura.guia.dt_retorno,
                            dc_valor_liberado: guia_fatura.guia.valor_total.recebido,
                            dc_valor_glosa: guia_fatura.guia.valor_total.glosado,
                            dc_valor_a_mais: guia_fatura.guia.valor_total.a_mais,
                        }
                    }
                ];
            } else { 
                return guia_fatura.guia.atendimento_procedimento_guias;
            }
        }
      );
    },

    datas_retornos: function() {

      if ( this.fatura && this.fatura.fl_reapresentacao ) {
        return _.mapValues(
          _.groupBy(this.fatura.item_reapresentacaos, ret =>
            ret.retorno_fatura && ret.retorno_fatura.dt_retorno ? ret.retorno_fatura.dt_retorno.substr(0, 10) : "-"
          ),
          (items, chave) => {
            if (!items) {
              return {
                recebido: 0,
                glosas: 0,
                a_mais: 0, 
                guias: 0,
                items: 0
              };
            }

            let qtde = _.uniqBy(items, "id_guia").length;
            let recebido = _.reduce(items, (total, item) => total + parseFloat(_.get(item, 'retorno_fatura.dc_valor_liberado', 0)), 0 );
            let glosas = _.reduce(items, (total, item) => total + parseFloat(_.get(item, 'retorno_fatura.dc_valor_glosa', 0)), 0 );
            let a_mais = _.reduce(items, (total, item) => total + parseFloat(_.get(item, 'retorno_fatura.dc_valor_a_mais', 0) ? _.get(item, 'retorno_fatura.dc_valor_a_mais', 0) : 0), 0 );

            return {
              recebido: recebido,
              glosas: glosas,
              a_mais: a_mais,
              guias: qtde,
              items: items,
              creditos: this.fatura.fatura_creditos.filter(fc => fc.dt_recebimento == chave),
              identificado: this.fatura.fatura_creditos.filter(fc => fc.dt_recebimento == chave)
                .reduce((total, fc) => total + parseFloat(fc.dc_valor), 0),
              retido: this.fatura.fatura_creditos.filter(fc => fc.dt_recebimento == chave)
                .reduce((total, fc) => total + parseFloat(fc.dc_retencoes), 0)
            };
          }
        );
      }

      console.log('retornos', this.retornos);

      let lista = _.mapValues(
        _.groupBy(this.retornos.filter(item => item.cd_valor_total != 0), ret =>
          ret.retorno.dt_retorno ? ret.retorno.dt_retorno.substr(0, 10) : "-"
        ),
        (items, chave) => {
          if (!items) {
            return {
              recebido: 0,
              glosas: 0,
              a_mais: 0, 
              guias: 0,
              items: 0
            };
          }

          //let recebido = _.sumBy(items, "retorno.dc_valor_liberado");
          //let glosas = _.sumBy(items, "retorno.dc_valor_glosa");
          let qtde = _.uniqBy(items, "id_guia").length;

          let recebido = _.reduce(items, (total, item) => { 
            let procs = parseFloat(_.get(item, 'retorno.dc_valor_liberado') ? _.get(item, 'retorno.dc_valor_liberado') : 0);

            let consumos = _.reduce(item.consumo_procedimentos, (tc, cm) => { 
                let valor_consumo = _.get(cm, 'retorno.dc_valor_liberado', _.get(cm, 'dc_valor_liberado', 0));
                return tc + parseFloat(valor_consumo ? valor_consumo : 0);
            }, 0);
            
            return total + procs + consumos;
          }, 0);

          let glosas = _.reduce(items, (total, item) => { 
                let procs = parseFloat(_.get(item, 'retorno.dc_valor_glosa') ? _.get(item, 'retorno.dc_valor_glosa') : 0);
                let consumos = _.reduce(item.consumo_procedimentos, (tc, cm) => { 
                    let valor_consumo = _.get(cm, 'retorno.dc_valor_glosa', _.get(cm, 'dc_valor_glosa', 0));
                    return tc + parseFloat(valor_consumo ? valor_consumo : 0);
                }, 0);

                return total + procs + consumos;
            }, 0 );

          let a_mais = _.reduce(items, (total, item) => total + parseFloat(_.get(item, 'retorno.dc_valor_a_mais') ? _.get(item, 'retorno.dc_valor_a_mais') : 0) +
              _.reduce(item.consumo_procedimentos, (tc, cm) => tc + parseFloat(_.get(cm, 'retorno.dc_valor_a_mais') ? _.get(cm, 'retorno.dc_valor_a_mais') : 0), 0), 0 );

          return {
            recebido: recebido,
            glosas: glosas,
            a_mais: a_mais,
            guias: qtde,
            items: items,
            creditos: this.fatura.fatura_creditos.filter(fc => fc.dt_recebimento == chave),
            identificado: this.fatura.fatura_creditos.filter(fc => fc.dt_recebimento == chave)
              .reduce((total, fc) => total + parseFloat(fc.dc_valor), 0),
            retido: this.fatura.fatura_creditos.filter(fc => fc.dt_recebimento == chave)
              .reduce((total, fc) => total + parseFloat(fc.dc_retencoes), 0)
          };
        }
      );

      this.fatura.fatura_creditos.forEach(fci => {
        if ( !lista[fci.dt_recebimento] ) {
          lista[fci.dt_recebimento] = {
            recebido: 0,
            glosas: 0,
            guias: 0,
            a_mais: 0, 
            items: [],
            creditos: this.fatura.fatura_creditos.filter(fc => fc.dt_recebimento == fci.dt_recebimento),
            identificado: this.fatura.fatura_creditos.filter(fc => fc.dt_recebimento == fci.dt_recebimento)
              .reduce((total, fc) => total + parseFloat(fc.dc_valor), 0),
            retido: this.fatura.fatura_creditos.filter(fc => fc.dt_recebimento == fci.dt_recebimento)
              .reduce((total, fc) => total + parseFloat(fc.dc_retencoes), 0)
          };
        }
      });

      return lista;
    },

    tem_bpa: function() {
      return (
        this.fatura &&
        this.fatura.guia_faturas.findIndex(
          item => item.guia.ch_tipo_guia == "B"
        ) >= 0
      );
    },

    tem_apac: function() {
      if ( !this.fatura )
        return false;

      if ( this.fatura.fl_reapresentacao ) { 
        return (
          this.fatura.item_reapresentacaos.findIndex(
            item => item.guia.ch_tipo_guia == "A"
          ) >= 0
        );
      } 

      return (
        this.fatura &&
        this.fatura.guia_faturas.findIndex(
          item => item.guia.ch_tipo_guia == "A"
        ) >= 0
      );
    },

    tem_aih: function() {
      return (
        this.fatura &&
        this.fatura.guia_faturas.findIndex(
          item => item.guia.ch_tipo_guia == "I"
        ) >= 0
      );
    },

    lista: function() {
      /*
      let pesquisar = this.search.trim();
      let parts = pesquisar.replace(" ", ".*");
      let match = parts;
      let reg = new RegExp(match, "i");
      */

      let reg = this.$util.getregex(this.search);

      let items;

      if (this.search) {
        items = this.fatura.guia_faturas.filter(item => {
          return reg.test(JSON.stringify(item));
        });
      } else {
        items = this.fatura.guia_faturas.filter(item => !this.id_contrato_operadora_selec || (item.guia && ( item.guia.id_contrato_operadora == this.id_contrato_operadora_selec)));
      }

      if (this.viewMode == "glosas") {
        return items.filter(item => item.guia.valor_total.glosado > 0);
      }

      if ( this.filtro_valor && this.filtro_valor != "T" ) {
        items = items.filter(item => ( this.filtro_valor == 'G' && item.guia.valor_total.glosado > 0 )
          || ( this.filtro_valor == 'R' && item.guia.valor_total.recebido > 0 )
          || ( this.filtro_valor == 'A' && item.guia.valor_total.a_receber > 0 )
        );
      }

      if (this.ordem) {
        let ordem = this.ordem;
        let items_o = _.sortBy(items, function(item) {
          return _.get(item, ordem.name);
        });

        if (this.ordem.direction == "desc") {
          items_o = _.reverse(items);
        }

        return items_o;
      } else {
        return items;
      }

    },

    lista_reap: function() {
      let reg = this.$util.getregex(this.search);
      let items;

      items = this.fatura.item_reapresentacaos.filter(item => !this.search || reg.test(JSON.stringify(item)));

      if (this.viewMode == "glosas")
        return items.filter(item => item.valor_total.glosado > 0);

      if ( this.filtro_valor && this.filtro_valor != "T" ) {
        items = items.filter(item => ( this.filtro_valor == 'G' && item.valor_total.glosado > 0 )
          || ( this.filtro_valor == 'R' && item.valor_total.recebido > 0 )
          || ( this.filtro_valor == 'A' && item.valor_total.a_receber > 0 )
        );
      }

      if (this.ordem) {
        let ordem = this.ordem;
        let items_o = _.sortBy(items, function(item) {
          return _.get(item, ordem.name);
        });

        if (this.ordem.direction == "desc") {
          items_o = _.reverse(items);
        }

        return items_o;
      } else {
        return items;
      }
    },

    selected: function() {
      if (!this.fatura) return false;

      return (
        this.lista.findIndex(item => {
          return item.guia.selected;
        }) >= 0
      );
    },

    selecteds: function() {
      if (!this.fatura) return [];

      if ( this.fatura.fl_reapresentacao ) {
        return this.lista_reap.filter(item => item.selected);
      }

      return this.lista.filter(item => item.guia.selected)
        .map(item => item.guia);
    },

    periodo: function() {
      if (!this.guias) return;

      let inicio = _.minBy(this.guias, item => {
        return item.dt_criacao.substr(0, 10);
      });

      let fim = _.maxBy(this.guias, item => {
        return item.dt_criacao.substr(0, 10);
      });

      return (
        "Período " +
        moment(inicio.dt_criacao.substr(0, 10), "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        ) +
        " a " +
        moment(fim.dt_criacao.substr(0, 10), "YYYY-MM-DD").format("DD/MM/YYYY")
      );
    },

    valor_total: function() {
      let init = { total: 0, glosado: 0, recebido: 0, a_receber: 0, a_mais: 0 };

      if ( this.fatura.fl_reapresentacao ) {

        return this.lista_reap.reduce((a, b) => {
          return {
            total: a.total + parseFloat(b.valor_total.total),
            glosado: a.glosado + parseFloat(b.valor_total.glosado),
            recebido:
              a.recebido +
              parseFloat(
                this.viewMode == "glosas"
                  ? b.valor_total.acatado
                  : b.valor_total.recebido
              ),
            a_mais: a.a_mais + parseFloat(b.valor_total.a_mais),
            a_receber:
              a.a_receber +
              parseFloat(
                this.viewMode == "glosas"
                  ? b.valor_total.reapresentado
                  : b.valor_total.a_receber
              )
          };
        }, init);

      }

      return this.lista.reduce((a, b) => {
        return {
          total: a.total + parseFloat(b.guia.valor_total.total),
          glosado: a.glosado + parseFloat(b.guia.valor_total.glosado),
          recebido:
            a.recebido +
            parseFloat(
              this.viewMode == "glosas"
                ? b.guia.valor_total.acatado
                : b.guia.valor_total.recebido
            ),
          a_mais: a.a_mais + parseFloat(b.guia.valor_total.a_mais),
          a_receber:
            Math.round( 
                ( 
                    a.a_receber +
                    parseFloat(
                    this.viewMode == "glosas"
                        ? b.guia.valor_total.reapresentado
                        : b.guia.valor_total.a_receber
                    )
                 ) * 100
            ) / 100
          /*
            Math.round(
                ( ( a.a_receber +
                parseFloat(
                this.viewMode == "glosas"
                    ? b.guia.valor_total.reapresentado
                    : b.guia.valor_total.a_receber ) ) * 100) / 100
            )
                    */
        };
      }, init);
    },
    valor_selecionado: function() {
      let init = { total: 0, glosado: 0, recebido: 0, a_receber: 0, a_mais: 0 };

      return this.selecteds.reduce((a, b) => {
        return {
          total: a.total + parseFloat(b.valor_total.total),
          glosado: a.glosado + parseFloat(b.valor_total.glosado),
          recebido:
            a.recebido +
            parseFloat(
              this.viewMode == "glosas"
                ? b.valor_total.acatado
                : b.valor_total.recebido
            ),
          a_mais: a.a_mais + parseFloat(b.valor_total.a_mais),
          a_receber:
            a.a_receber +
            parseFloat(
              this.viewMode == "glosas"
                ? b.valor_total.reapresentado
                : b.valor_total.a_receber
            )
        };
      }, init);
    },

    faturaIdContratoOperadora: function() { 
      let id = null;

      if(this.fatura && this.fatura.guia_fatura && this.fatura.guia_fatura.guia && this.fatura.guia_fatura.guia.contrato_operadora) {
        id = this.fatura.guia_fatura.guia.contrato_operadora.id_contrato_operadora;
      }

      return id;
    },

    faturaNomeContratado: function() { 
      let nome = null;

      if(this.fatura && this.fatura.guia_fatura && this.fatura.guia_fatura.guia && this.fatura.guia_fatura.guia.contrato_operadora) {
        nome = this.fatura.guia_fatura.guia.contrato_operadora.st_nome_contratado;
      }

      return nome;
    },
    
    faturaUnidadeOperacao: function() {
      if(this.fatura && this.fatura.guia_fatura && this.fatura.guia_fatura.guia && this.fatura.guia_fatura.guia.contrato_operadora && this.fatura.guia_fatura.guia.contrato_operadora.id_unidade_operacao_reembolso_nf) {
        return this.fatura.guia_fatura.guia.contrato_operadora.id_unidade_operacao_reembolso_nf;
      } 

      if(this.fatura && this.fatura.guia_fatura && this.fatura.guia_fatura.guia && this.fatura.guia_fatura.guia.atendimento && this.fatura.guia_fatura.guia.atendimento.unidade_operacao) {
        return this.fatura.guia_fatura.guia.atendimento.unidade_operacao.id_unidade_operacao;
      } 

      return null;
    },

    faturaCodigoContratado: function() {
       let codigo = null;

      if(this.fatura && this.fatura.guia_fatura && this.fatura.guia_fatura.guia && this.fatura.guia_fatura.guia.contrato_operadora) {
        codigo = this.fatura.guia_fatura.guia.contrato_operadora.st_numero_prestador;

        if(codigo && this.$util.validarcpf(codigo)) {
          codigo = "CPF: " + codigo;
        } else if(codigo && this.$util.validarcnpj(codigo)) {
          codigo = "CNPJ: " + codigo;
        } else {
          codigo = null;
        }

      }

      return codigo;
    },

    podeEmietirNotaFiscal: function() {
        if ( !this.fatura ) {
            return false;
        }

        if ( this.fatura.fl_reapresentacao ) { 

            return this.fatura.item_reapresentacaos
                && this.fatura.item_reapresentacaos[0]
                && this.fatura.item_reapresentacaos[0].guia
                && this.fatura.item_reapresentacaos[0].guia.atendimento
                && this.fatura.item_reapresentacaos[0].guia.atendimento.unidade_operacao
                && this.fatura.item_reapresentacaos[0].guia.atendimento.unidade_operacao.fl_nota_fiscal;

        }

        return this.fatura
            && this.fatura.guia_fatura
            && this.fatura.guia_fatura.guia
            && this.fatura.guia_fatura.guia.atendimento
            && this.fatura.guia_fatura.guia.atendimento.unidade_operacao
            && this.fatura.guia_fatura.guia.atendimento.unidade_operacao.fl_nota_fiscal;
    },

    podeGerarXml: function() {
        let multiplosTipos = false

        if(this.fatura && this.fatura.guia_faturas) {

            const guiaFatura = _.first(this.fatura.guia_faturas);
            if(guiaFatura) {
                multiplosTipos =
                    this.fatura.guia_faturas.findIndex(
                        item => item.guia.ch_tipo_guia != guiaFatura.guia.ch_tipo_guia
                    ) >= 0;

            }


        }

        return !multiplosTipos;
    }

  },

  mounted() {
    this.unidade = this.$store.state.unidade;
  },

  beforeDestroy() {
  },

  methods: {
    editar_data_movimentacao (item, grupo) { 
        this.$refs.edit_data_mov.abrir(item, grupo);
    },

    imprimir_laudos () { 
        if(!this.selecteds || this.selecteds.length == 0) {
            this.$toast.add({
                severity: "warn",
                summary: "Atenção",
                detail: "Selecione ao menos uma guia para imprimir os laudos",
                life: 5000
            });
            return;
        }

        if ( !confirm('Confirma imprimir os laudos das guias selecionadas?') ) { 
            return;
        }

        this.dispatch_titulo = "Processando laudos para impressão...";

        const idGuias = this.selecteds.map(guia => {
            return guia.id_guia;
        });

        const jobId = this.$util.uuidv4();

        this.$refs.dispatchModal.executar_com_progresso(
            "gerar_multiplos_laudos",
            "guias",
            {
                guias: idGuias,
                job_id: jobId
            },
            'processar-' + jobId,
            'processar-' + jobId + "-progresso",
            true
        );
    },

    gerar_multiplos_laudos_fim(res) {
        console.log('res', res);

        if (res && res.data && res.data.token) {
            this.$util.print_preview('/imprimir/guia/laudo', false, { "token": res.data.token }); 
            return;  
        }

        if (res && res.data && res.data.erro) {
            this.$toast.add({
                severity: "error",
                summary: "Erro",
                detail: res.data.msg ? res.data.msg : "Erro ao gerar laudos",
                life: 5000
            });
        }
        
    },

    imprimir_anexos () { 
        this.$refs.imprimir_anexos.abrir(this.selecteds);
    },

    editar_contrato_guias (contrato) {
        let guias = this.lista.map(item => item.guia)
            .filter(guia => guia.id_contrato_operadora == contrato.id_contrato_operadora);

        this.$refs.editar_contrato_guias.abrir(guias, contrato);
    },

    ver_pacote (guia) { 
        this.info_pacote = { 
            paciente: guia.atendimento.paciente,
            id_atendimento: guia.id_atendimento,
        };

        this.$refs.historico_fatura_pacotes.abrir(guia.atendimento.id_paciente);
    },

    ver_retorno_datas(item, guia) { 
        this.$refs.retorno_datas.abrir(item, guia);
    },

    abrir_contatos () { 
        this.$util.load(this, { 
            service: 'faturas',
            func: 'show',
            parms: { 
                id: this.fatura.id_fatura, 
                contatos: true, 
            },
            loadTo: res => { 
                this.edicao_contato = res;
                this.lista_status = res.lista_status ? res.lista_status : []; 

                this.edicao_contato.model = { 
                    type: 'fatura',
                    id: this.fatura.id_fatura,
                };

                this.$refs.regcontatos.editar(this.edicao_contato);
            }
        });
    },

    expandir_guia(guia) { 
        if ( !guia.guia.expanded ) { 

            console.log('expandir_guia', guia);

            if ( guia.guia.resumido == 'S' 
                || ( guia.guia.atendimento_procedimento_guias && guia.guia.atendimento_procedimento_guias.find(apg => apg.consumo_procedimentos && apg.consumo_procedimentos.find(cpg => cpg.qtde > 0)) ) ) { 

                this.$util.load(this, { 
                    service: 'faturas',
                    func: 'show', 
                    parms: { 
                        id: this.fatura.id_fatura,
                        id_guia: guia.guia.id_guia, 
                        fatura: true, 
                    },
                    loadTo: res => { 
                        guia.guia = res.guia_faturas[0].guia;
                        guia.guia.expanded = true;
                    }
                });

                return;
            }
        }

        guia.guia.expanded = !guia.guia.expanded;
    },
    
    identificar_nota_fiscal (credito) { 
      this.$refs.ident_nf.abrir(credito);
    },

    abrir_log_int() { 
        this.$refs.logint.abrir('fatura', this.fatura.id_fatura, true);
    },

    possuiGuiaTipo(tipo) {
        let podeGerar = false

        if(this.fatura && this.fatura.guia_faturas) {
            podeGerar =
                this.fatura.guia_faturas.findIndex(
                    item => item.guia.ch_tipo_guia == tipo 
                ) >= 0;
        }

        return podeGerar;
    },

    possuiMaisDe100(tipo) {
        let possui = false

        if(this.fatura && this.fatura.guia_faturas) {
            possui = _.filter(this.fatura.guia_faturas, item => item.guia.ch_tipo_guia == tipo).length > 100;
        }

        return possui;
    },

    ajustar_vencimento () { 
      this.edicao_vencimento = moment(this.edicao_vencimento).add(this.dias_somar_vencimento, "days").format('YYYY-MM-DD');
      this.acrescentar_dias = false;
    },

    editar_protocolo () { 
      this.validate = false;
      this.edicao_protocolo = null;

      this.$nextTick(() => { 
        this.edicao_protocolo = _.cloneDeep(this.fatura.fatura_envio);
        $('#edicaoProtocoloModal').modal('show');
      });
    },

    salvar_edicao_protocolo () { 
      this.$util.atualizar(this, { 
        service: 'faturas',
        func: 'salvar_envio',
        dados: this.edicao_protocolo, 
        modal: 'edicaoProtocoloModal',
        toast: true, 
        msg: 'Protocolo atualizado.',
        callback: () => {
          this.abrirFatura(this.fatura);
        }
      });
    },

    editar_emissao () { 
      this.edicao_emissao = this.fatura.dt_emissao;
      $('#emissaoModal').modal('show');
    },

    filtrar_creditos (lista) {
      let reg = this.$util.getregex(this.filtro_texto_credito);

      return _.sortBy(
        lista.filter(credito => !this.filtro_data_credito || credito.usado || this.filtro_data_credito <= credito.dt_baixa.substr(0,10))
          .filter(credito => !this.filtro_data_ate_credito || credito.usado || this.filtro_data_ate_credito >= credito.dt_baixa.substr(0,10))
          .filter(credito => credito.usado 
            || ( 
              reg.test(JSON.stringify(credito))
              && ( 
                !this.filtro_unidade_credito
                || credito.lancamento.id_unidade_operacao == this.filtro_unidade_credito
              )
              && ( 
                !this.filtro_categoria_credito 
                || !this.fatura 
                || !this.fatura.operadora 
                || !this.fatura.operadora.categoria
                || this.fatura.operadora.id_categoria == credito.lancamento.id_categoria
              )
            )
          ),
        'dt_baixa'
      );
    },

    salvar_emissao() { 
      this.$util.atualizar(this, {
        service: 'faturas',
        func: 'salvar_emissao',
        dados: {
          id_fatura: this.fatura.id_fatura,
          dt_fim: this.fatura.dt_fim ? this.fatura.dt_fim.substr(0,10) : this.$util.hoje(),
          dt_emissao: this.edicao_emissao,
        },
        modal: 'emissaoModal',
        toast: true,
        msg: 'Emissão atualizada.',
        callback: () => {
          this.abrirFatura(this.fatura);
        }
      });
    },

    salvar_vencimento() {
      this.$util.atualizar(this, {
        service: 'faturas',
        func: 'salvar_vencimento',
        dados: {
          id_fatura_envio: this.fatura.fatura_envio.id_fatura_envio,
          dt_envio: this.fatura.fatura_envio.dt_envio,
          dt_vencimento: this.edicao_vencimento,
        },
        modal: 'vencimentoModal',
        toast: true,
        msg: 'Vencimento atualizado.',
        callback: () => {
          this.abrirFatura(this.fatura);
        }
      });
    },

    editar_vencimento() {
      this.edicao_vencimento = this.fatura.fatura_envio.dt_vencimento;
      $('#vencimentoModal').modal('show');
    },

    to_array(obj) {
      return _.values(obj);
    },

    listar_guias_do_credito(referencia) {
      $('.modal').modal('hide');

      this.filtrar('M' + this.$util.getFormatDate(referencia));
      this.filtro_valor = 'T';
      this.viewMode = 'guias';
    },

    teste_search(texto) { 
        return this.search && texto && ( this.search == '"' + texto + '"' );
    },

    filtrar (texto) {
      let filtro = '"' + texto + '"';
      this.search = this.search == filtro ? '' : filtro;
    },

    total_retencoes(credito) {
      return this.lista_retencoes(credito).reduce((total, item) => {
        return total + item.dc_valor_retido;
      }, 0);
    },

    lista_retencoes(credito) {
      return credito.retencoes.filter(item => item.fl_ativo);
    },

    incluir_imposto(credito) {
      credito.retencoes.push({
        id_fatura_credito_retencoes: null,
        fl_ativo: true,
        st_imposto: "",
        dc_valor_retido: 0,
      });
    },

    calc_impostos(credito, do_total = false) {

      this.calculando_imposto = true; 

      this.$nextTick(() => { 

        let impostos = [
          'pis',
          'cofins',
          'csll',
          'iss',
          'inss',
          'irrf',
        ];

        let perc_ret_total = 0;
        let imposto_total = 0;

        impostos.forEach(item => {
          if ( this.fatura.operadora['fl_retem_' + item] ) {
            perc_ret_total += this.fatura.operadora['dc_' + item];
          }
        });

        if ( do_total ) { 

          credito.fl_ret_do_total = do_total;
          credito.valor_total = credito.dc_valor_uso;

          this.$forceUpdate();

        }

        let valor_base = ( credito.dc_valor_uso / ( 1 - ( ( do_total ? 0 : perc_ret_total ) / 100 ) ) );

        impostos.forEach(item => {

          if ( !this.fatura.operadora['fl_retem_' + item] )
            return;

          let valor = Math.round( ( valor_base * this.fatura.operadora['dc_' + item] ) ) / 100;

          if ( item == 'irrf' && valor < 10 ) { 
            return;
          }

          imposto_total += valor;

          if ( do_total ) { 
            credito.dc_valor_uso = credito.dc_valor_uso - valor;
          }

          credito.retencoes.push({
            id_fatura_credito_retencoes: null,
            fl_ativo: true,
            st_imposto: item.toUpperCase(),
            dc_valor_retido: valor,
          });

        });

        credito.dc_valor_retencoes = imposto_total;

        if ( !credito.retencoes.length ) {
          credito.retencoes.push({
            id_fatura_credito_retencoes: null,
            fl_ativo: true,
            st_imposto: "",
            dc_valor_retido: 0,
          });
        }

        this.calculando_imposto = false;

      });

    },

    editar_protocolo_reap_guia(item) {
      this.protocolo_recurso = _.cloneDeep(item);

      $('#protocoloGuiaReapModal').modal('show');
    },

    salvar_protocolo_recurso () {
      this.$util.atualizar(this, {
        service: 'faturas',
        func: 'protocolo_recurso',
        dados: this.protocolo_recurso,
        modal: 'protocoloGuiaReapModal',
        callback: () => {
          this.abrirFatura(this.fatura);
        }
      });
    },

    copiar_motivo_glosa(guia, motivo) {

      guia.atendimento_procedimento_guias.forEach(apg => {
        if ( apg.retorno.valor_glosa_editar && apg.selected )
          apg.retorno.motivo_glosa = motivo;

        apg.consumo_procedimentos.forEach(cpg => {
          if ( cpg.retorno.valor_glosa_editar && cpg.selected )
            cpg.retorno.motivo_glosa = motivo;
        });
      });

    },

    remover_identificacao_credito() {
      if ( !confirm('Confirma remover a identificação do crédito?') )
        return;

      this.$util.atualizar(this, {
        service: 'faturas',
        func: 'identificar_creditos',
        dados: {
          id_fatura: this.fatura.id_fatura,
          creditos: [
            { id_baixa: -1 }
          ],
          dt_recebimento: this.creditos.data,
        },
        modal: 'identificarCreditosModal',
        toast: true,
        callback: () => {
          this.abrirFatura(this.fatura, true);
        }
      })
    },

    validar_creditos () {
      return (
        Math.round(this.creditos.recebido * 100) == Math.round(this.totalizar_total() * 100) 
        // (this.creditos.lista, 'dc_valor_uso') + this.totalizar_credito_retencoes() )
      );
    },

    atualizar_credito () {
      if ( !this.validar_creditos() ) {
        this.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail: "Valor divergente.",
          life: 3000
        });
        return;
      }

      this.creditos.lista.forEach(item => { 
        if ( item.fl_ret_do_total ) { 
          item.dc_valor_uso = item.valor_total - this.total_retencoes(item);
        }
      });

      this.$util.atualizar(this, {
        service: 'faturas',
        func: 'identificar_creditos',
        dados: {
          id_fatura: this.fatura.id_fatura,
          creditos: this.creditos.lista,
          dt_recebimento: this.creditos.data,
          credito_nf: this.credito_nf,
        },
        modal: 'identificarCreditosModal',
        toast: true,
        callback: () => {
          this.abrirFatura(this.fatura, true);
        }
      })
    },

    totalizar_credito_retencoes() {
      if ( !this.creditos || !this.creditos.lista )
        return 0;

      return this.creditos.lista.filter(item => item.usado)
        .reduce((total, item) => {
          return total + this.total_retencoes(item);
        }, 0);
    },

    totalizar_uso () { 

      if ( !this.creditos || !this.creditos.lista )
        return 0;

      return this.creditos.lista.filter(item => item.usado)
        .reduce((total, item) => {
          return total + ( item.fl_ret_do_total ? item.valor_total - this.total_retencoes(item) : item.dc_valor_uso );
        }, 0);

    },

    totalizar_total () { 

      if ( !this.creditos || !this.creditos.lista )
        return 0;

      return this.creditos.lista.filter(item => item.usado)
        .reduce((total, item) => {
          return total + ( !item.fl_ret_do_total ? item.dc_valor_uso + this.total_retencoes(item) : item.valor_total );
        }, 0);

    },

    totalizar(lista, campo) {
      return lista.filter(item => item.usado)
        .reduce((total, item) => {
          return total + item[campo]
        }, 0);
    },

    totalizar_lista(lista, campo) {
      return lista.reduce((total, item) => {
          return total + parseFloat(_.get(item, campo))
        }, 0);
    },

    listar_creditos (item, data) {
      this.creditos_ident = {
        lista: [],
        data: data,
        recebido: item.recebido,
        item: item
      };

      $('#listarCreditosModal').modal('show');
    },

    identificar_credito(item, data, refresh = false) {
      if ( !refresh ) { 
        this.creditos = null;
        this.block_filtro_credito = false;
        this.block_filtro_credito_operadora = false;
        this.filtro_unidade_credito = "";
        this.filtro_data_credito = "";
        this.filtro_data_ate_credito = "";
        $('#identificarCreditosModal').modal('show');
      }
      
      this.$util.load(this, {
        service: 'faturas',
        func: 'listar_creditos',
        parms: {
          id_fatura: this.fatura.id_fatura,
          dt_recebimento: data,
          block_filtro: this.block_filtro_credito,
          block_filtro_operadora: this.block_filtro_credito_operadora,
          inicio: this.filtro_data_credito,
          fim: this.filtro_data_ate_credito,
        },
        loadTo: res => {
          console.log('lc', res);
          console.log('lc-item', item);

          this.creditos = {
            lista: res,
            data: data,
            recebido: item.recebido + item.a_mais,
            item: item
          };

          this.credito_nfs = null;
          this.credito_nf = null;

          if(this.podeEmietirNotaFiscal) {
              this.$util.load(this, {
                service: 'nota_fiscal_servico',
                func: 'listar_nfs_pag_fat',
                parms: {
                  id_operadora: this.fatura.id_operadora,
                  data_envio: this.fatura.dt_emissao,
                  creditos: item && item.creditos ? item.creditos : null,
                },
                loadTo: nfs => {
                    this.credito_nfs = nfs;
                    // verificar se os creéditos ja tem nf vinculada e selecionar a nf
                    this.creditos.lista.forEach(item => {
                        if(this.credito_nf == null && item.usado && item.id_nota_fiscal_servico) {
                            this.credito_nf = item.id_nota_fiscal_servico;
                        }
                    })
            
                }
              });
           }

        }
      });
    },

    add_reapresantecao() {
      $('#selecionarReapresentacaoModal').modal('show');
    },

    lista_items(items) {
      return items.filter(item => this.viewMode != 'glosas' || item.retorno.dc_valor_glosa > 0);
    },

    editar_justificativa(item) {
      this.justificativa = {
        texto: item.st_justificativa,
        item: item,
      };

      $('#justificativaModal').modal('show');
    },

    justificar_reapresentacao() {
      this.justificativa = {
        texto: "",
        item: null
      };

      $('#justificativaModal').modal('show');
    },

    salvar_justificar_reapresentacao() {
      this.$util.atualizar(this, {
        service: 'faturas',
        func: 'justificar',
        dados: {
          items: this.justificativa.item ? [ this.justificativa.item.id_item_reapresentacao ] : this.selecteds.map(item => item.id_item_reapresentacao),
          justificativa: this.justificativa.texto,
        },
        modal: 'justificativaModal',
        toast: true,
        callback: () => this.abrirFatura(this.fatura),
      });
    },

    editar_nota_fiscal() {
        this.nota_fiscal = _.cloneDeep(this.fatura.fatura_envio);

        // Verificar se pode emitir nota fiscal
        if (this.podeEmietirNotaFiscal) {
            
            this.$refs.notaFiscalGeracaoRef.emitirNotaFiscalFatura(this.fatura);
        } else {
            $("#notaFiscalModal").modal("show");
        }
    },

    informar_nota_fiscal() {
        this.nota_fiscal = _.cloneDeep(this.fatura.fatura_envio);

        $("#notaFiscalModal").modal("show");
    },

    salvar_nota_fiscal() {
      this.$util.atualizar(this, {
        service: "faturas",
        func: "salvar_envio",
        modal: "notaFiscalModal",
        dados: {
            id_fatura_envio: this.fatura.fatura_envio.id_fatura_envio,
            st_nota_fiscal: this.nota_fiscal.st_nota_fiscal,
            dt_vencimento: this.nota_fiscal.dt_vencimento,
        },
        toast: true,
        callback: () => {
            this.fatura.fatura_envio.st_nota_fiscal = this.nota_fiscal.st_nota_fiscal;
            this.fatura.fatura_envio.dt_vencimento = this.nota_fiscal.dt_vencimento;
        }
      });
    },

    anexar() {
      this.$refs.upload.abrir();
    },

    editar_observacao() {
      this.edicao_obs = _.cloneDeep(this.fatura);
      $("#modalFaturaObs").modal("show");
    },

    salvar_observacao() {
      this.$util.atualizar(this, {
        service: "faturas",
        func: "store",
        dados: this.edicao_obs,
        modal: "modalFaturaObs",
        callback: () => {
          this.abrirFatura(this.fatura, true);
        }
      });
    },

    onSelectAll() {

      if ( this.fatura.fl_reapresentacao ) {

        this.lista_reap.forEach(item => {
          item.selected = this.selectAll;
        });

        return;

      }

      this.lista.forEach(item => {
        item.guia.selected = this.selectAll;
      });

    },

    calcular_valor_item(proc) {
      proc.retorno.calcular = true;

      this.$nextTick(() => {
        proc.retorno.valor_liberado_editar =
          proc.valor_total - proc.retorno.valor_glosa_editar;
        proc.retorno.calcular = false;
      });
    },

    calcular_qtde_item(proc) {
      if ( !proc.retorno.qtde_glosa_editar && proc.retorno.qtde_glosa_editar !== 0 )
        return;

      proc.retorno.calc_qtd = true;

      this.$nextTick(() => {
        if ( proc.retorno.qtde_glosa_editar >= 0 && proc.retorno.qtde_glosa_editar <= ( proc.in_quantidade ? proc.in_quantidade : proc.dc_quantidade ) ) {
          proc.retorno.valor_glosa_editar = proc.dc_valor * proc.retorno.qtde_glosa_editar;
          proc.retorno.valor_liberado_editar = proc.valor_total - proc.retorno.valor_glosa_editar;
        }

        proc.retorno.calc_qtd = false;
      });
    },

    retirar_da_fatura() {
      let msg =
        this.selecteds.length == 1
          ? "a guia selecionada"
          : "as guias selecionadas";

      if (!confirm("Confirmar remover " + msg + " da fatura?")) return;

      this.$util.atualizar(this, {
        service: "guias",
        func: "retirar",
        dados: {
          qtd: this.selecteds.length,
          guias: this.selecteds.map(item => {
            return {
              id_item_reapresentacao: item.id_item_reapresentacao,
              id_guia: item.id_guia,
              ch_status: item.ch_status
            };
          }),
          reapresentacao: this.fatura.fl_reapresentacao,
        },
        callback: () => {
          this.abrirFatura(this.fatura, true);
        }
      });
    },

    imprimir() {
      $('[data-toggle="tooltip"]').tooltip("dispose");
      $("#imprimirModal").modal("show");
    },

    assinaturaReport() {
      return (
        moment().format("DD [de] MMMM [de] YYYY")
      );

      // this.unidade.endereco.cidade.st_cidade + ",  " +

    },

    imprimirEspelho() {
      this.$util.print_preview('imprimir/fatura/' + this.fatura.id_fatura, true);
    },

    imprimirCapaFatura() {

      console.log(this.fatura)
      console.log("Imprimir capa");

      this.imprimindo_capa = true;

      this.$nextTick(() => { 

        this.$refs.htmlReportRef.configurarPapel("A4");
        this.$nextTick(() => {
          const configPrint = {
            styles: [
              "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css"
              // "landscape.css"
            ]
          };

          this.$htmlToPaper("printCapaFatura", configPrint, () =>
            console.log("printed...")
          );
        });

      });
    },

    coluna3(item) {
      return this.viewMode == "glosas" ? item.acatado : item.recebido;
    },

    coluna4(item) {
      return this.viewMode == "glosas" ? item.reapresentado : item.a_receber;
    },

    procSelected(lista) {
      return lista.find(item => item.selected || ( item.consumo_procedimentos && item.consumo_procedimentos.find(consumo => consumo.selected))) ? true : false;
    },

    desabilitar(botao) {
      if ( this.$store.state.loading )
        return true;

      if (botao == "justificar") {
        return (this.selecteds.length == 0);
      } else if (botao == "remover") {
        return (
          this.fatura.ch_status == "FP" ||
          (this.selecteds.length == 0 ||
            this.selecteds.findIndex(item => {
              return item.ch_status != "EF"
                && ( item.ch_status != "FT" || !this.fatura.pode_remover_guia_faturada );
            }) >= 0)
        );
      } else if (botao == "pendenciar") {
        return (
          this.fatura.ch_status == "FP" ||
          (this.selecteds.length == 0 ||
            this.selecteds.findIndex(item => {
              return item.selected && item.ch_status != "EF";
            }) >= 0)
        );
      } else if (botao == "receber") {
        return (
          this.selecteds.length == 0 ||
          this.selecteds.find(item => {
            return item.selected && item.valor_total && item.ch_status != 'FT' && Math.round(item.valor_total.a_receber * 100) == 0; // item.ch_status != "FT";
          })
        );
      } else if (botao == "recalcular") {
        return (
          this.selecteds.length == 0 ||
          this.selecteds.findIndex(item => {
            return item.selected && item.ch_status != "EF";
          }) >= 0
        );
      } else if (botao == "glosar") {
        return (
          this.selecteds.length == 0 ||
          this.selecteds.findIndex(item => {
            return item.selected && item.ch_status != "FT" && item.ch_status != "GP" && Math.round(item.valor_total.a_receber * 100) == 0;
          }) >= 0
        );
      } else if (botao == "cancelar-mov") {
        // || ( item.valor_total && item.valor_total.reapresentado > 0 )
        return (
          this.selecteds.length == 0 ||
          this.selecteds.findIndex(item => {
            return (
              item.selected &&
              (
                (
                  item.ch_status != "GT" &&
                  item.ch_status != "RC" &&
                  item.ch_status != "GP" &&
                  item.ch_status != "RP"
                )
              )
            );
          }) >= 0
        );
      }
    },

    teste() {
      console.log("Update");
      $('[data-toggle="tooltip"]').tooltip("update");
    },

    desabilitar_reap(botao) {
      // add_reap, criar_reap, cancelar-analise, reap-tudo, acatar-tudo

      if (botao == "add_reap") {
        return (
          this.selecteds.length == 0 ||
          this.selecteds.findIndex(item => {
            return item.valor_total.reapresentar == 0;
          }) >= 0
        );
      } else if (botao == "criar_reap") {
        return (
          this.selecteds.length == 0 ||
          this.selecteds.findIndex(item => {
            return item.valor_total.reapresentar == 0;
          }) >= 0
        );
      } else if (botao == "cancelar-analise") {
        return (
          this.selecteds.length == 0 ||
          this.selecteds.findIndex(item => {
            return (
              !item.valor_total.glosado ||
              !item.valor_total.acatado ||
              item.valor_total.reapresentado
            );
          }) >= 0
        );
      } else if (botao == "reap-tudo") {
        return (
          this.selecteds.length == 0 ||
          this.selecteds.findIndex(item => {
            return (
              item.valor_total.glosado -
                item.valor_total.acatado -
                item.valor_total.reapresentar ==
              0
            );
          }) >= 0
        );
      } else if (botao == "acatar-tudo") {
        return (
          this.selecteds.length == 0 ||
          this.selecteds.findIndex(item => {
            return !item.valor_total.glosado || item.valor_total.acatado || item.reapresentado;
          }) >= 0
        );
      }
    },

    glosar_guias() {
      this.validate = false;

      this.glosar = { 
        id_motivo_glosa: null,
        escopo: "T",
        procedimento: "", 
        valor: 0, 
        receber_complemento: false, 
      };

      $("#glosarGuiasModal").modal("show");
    },

    recalcular () { 

      if ( !confirm ('Confirma recalcular as guias selecionadas?') ) 
        return;

      this.dispatch_titulo = "Recalcular guias selecionadas...";

      this.$refs.dispatchModal.executar_chunck(
          "guias",
          "recalc_valores",
          this.selecteds.map(item => { 
            return { 
              id_guia: item.id_guia
            };
          }),
          'guias',
          {},
          50
      );

    },

    enviar_guias_para_glosar() {
        this.dispatch_titulo = "Glosando guias...";

        this.$refs.dispatchModal.executar_chunck(
            "faturas",
            "movimentar",
            this.selecteds,
            'guias',
            {
                dt_retorno: this.dt_retorno,
                id_motivo_glosa: this.glosar.id_motivo_glosa,
                tipo: ( this.glosar.escopo == 'P' || this.glosar.escopo == 'C' || this.glosar.escopo == 'X' ) ? "GP" : "GT",
                reapresentacao: this.fatura.fl_reapresentacao,
                escopo: this.glosar.escopo, 
                receber_complemento: this.glosar.receber_complemento, 
                id_procedimento: this.glosar.escopo == 'C' ? -1 : ( this.glosar.procedimento ? this.glosar.procedimento.id_procedimento : null ), 
                consumo: this.glosar.consumo,
                valor: this.glosar.valor, 
                total_geral: this.selecteds.reduce((total, item) => { 
                    return total + ( item.valor_total.total ? item.valor_total.total : 0 ); 
                }, 0)
            },
            5
        );

    //   this.$util.atualizar(this, {
    //     service: "faturas",
    //     func: "movimentar",
    //     modal: "glosarGuiasModal",
    //     dados: {
    //       guias: this.selecteds,
    //       dt_retorno: this.dt_retorno,
    //       id_motivo_glosa: this.glosar.id_motivo_glosa,
    //       tipo: "GT",
    //       reapresentacao: this.fatura.fl_reapresentacao,
    //     },
    //     callback: () => {
    //       this.abrirFatura(this.fatura, true);
    //     }
    //   });
    },
    refresh_movimentar(res) {
        if ( this.dispatch_titulo == "Processando laudos para impressão..." ) { 
            this.gerar_multiplos_laudos_fim(res);
            return; 
        }

        $("#glosarGuiasModal").modal("hide");
        $("#retornoFaturaModal").modal("hide");

        this.abrirFatura(this.fatura, true);
    },
    movimentar_guia(guia) {
        this.pode_valor_a_mais = null; 

        if ( this.viewMode == 'glosas' ) {
            this.$util.atualizar(this, {
                service: "faturas",
                func: "analisar_glosa_guia",
                dados: {
                    guia: guia,
                },
                callback: () => {
                    this.abrirFatura(this.fatura, true);
                }
            });
            return;
        }

        if (
            guia &&
            guia.atendimento_procedimento_guias.find(
                item =>
                    (
                    item.retorno.valor_glosa_editar > 0 &&
                    (!item.retorno.motivo_glosa || !item.retorno.motivo_glosa.in_codigo)
                    ) ||
                    (
                    item.consumo_procedimentos.find(consumo =>
                        consumo.retorno.valor_glosa_editar > 0 &&
                        (!consumo.retorno.motivo_glosa || !consumo.retorno.motivo_glosa.in_codigo))
                    )
            )
        ) {
            this.$toast.add({
                severity: "error",
                summary: "Atenção",
                detail: "Informe o motivo da glosa.",
                life: 3000
            });

            return;
        }

        if (
            guia &&
            guia.atendimento_procedimento_guias.find(
            item =>
                !item.retorno.valor_glosa_editar && item.retorno.valor_liberado_editar && item.retorno.valor_liberado_editar > item.valor_total 
                ||
                (
                    item.consumo_procedimentos.find(consumo =>
                        !consumo.retorno.valor_glosa_editar && consumo.retorno.valor_liberado_editar && consumo.retorno.valor_liberado_editar > consumo.valor_total 
                    )
                )
            )
        ) {
            this.pode_valor_a_mais = false;
        } else { 
            console.log('guia', guia);
        }

        this.mov_guia = guia;
        $("#retornoFaturaModal").modal("show");
    },

    salvar_movimentar_guia() {
      if (
        this.dt_retorno &&
        this.dt_retorno < this.fatura.fatura_envio.dt_envio.substr(0, 10) && 
        !this.eh_reembolso
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail:
            "A data da movimentação não pode ser anterior a data de envio da fatura.",
          life: 3000
        });
        return;
      }

      this.$util.atualizar(this, {
        service: "faturas",
        func: "movimentar_guia",
        dados: {
            guia: this.mov_guia,
            dt_retorno: this.dt_retorno,
            pode_a_mais: this.pode_valor_a_mais
        },
        modal: "retornoFaturaModal",
        callback: () => {
            this.abrirFatura(this.fatura, true);
        }
      });
    },

    receber() {
      this.mov_guia = null;
      this.pode_valor_a_mais = null; 
      
      $("#retornoFaturaModal").modal("show");
    },

    salvar_receber() {
      if ( !this.fatura.fatura_envio ) { 
        this.$toast.add({
          severity: "error",
          summary: "Receber",
          detail:
            "Fatura ainda não marcada como enviada.",
          life: 3000
        });
        return;
      }

      if (
        this.dt_retorno &&
        this.dt_retorno < this.fatura.fatura_envio.dt_envio.substr(0, 10) && 
        !this.eh_reembolso
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail:
            "A data da movimentação não pode ser anterior a data de envio da fatura.",
          life: 3000
        });
        return;
      }

      this.dispatch_titulo = "Recebendo guias...";

      this.$refs.dispatchModal.executar_chunck(
            "faturas",
            "movimentar",
            this.selecteds,
            'guias',
            {
                tipo: "RC",
                dt_retorno: this.dt_retorno,
                reapresentacao: this.fatura.fl_reapresentacao,
            },
           50
        );

    //   this.$util.atualizar(this, {
    //     service: "faturas",
    //     func: "movimentar",
    //     dados: {
    //       guias: this.selecteds,
    //       tipo: "RC",
    //       dt_retorno: this.dt_retorno,
    //       reapresentacao: this.fatura.fl_reapresentacao,
    //     },
    //     modal: "retornoFaturaModal",
    //     callback: () => {
    //       this.abrirFatura(this.fatura, true);
    //     }
    //   });
    },

    acatar_justificativa () { 

      this.texto_acatar_justificativa = "";
      $('#acatarGuiasJustificativa').modal('show');

    },

    // Análise de Glosa

    analisar_glosa(acao) {
      $('[data-toggle="tooltip"]').tooltip("dispose");

      let modal = ( acao == 'acatar' ? 'acatarGuiasJustificativa' : '' );

      this.$util.atualizar(this, {
        service: "faturas",
        func: "analisar_glosa",
        dados: {
          guias: this.selecteds.map(item => {
            return this.fatura.fl_reapresentacao
              ? {
                  id_item_reapresentacao: item.id_item_reapresentacao,
                  dc_valor_glosado: item.valor_total.acatado_editar,
                }
              : { id_guia: item.id_guia };
          }),
          acao: acao,
          reapresentacao: this.fatura.fl_reapresentacao,
          texto_acatar_justificativa: this.texto_acatar_justificativa, 
        },
        callback: () => {
          this.abrirFatura(this.fatura, true);
        },
        modal: modal,
      });
    },

    salvar_add_reapresentacao(reap) {

      this.$util.atualizar(this, {
        service: "faturas",
        func: "adicionar",
        dados: {
          id: reap.id_fatura,
          id_origem: this.fatura.id_fatura, 
          guias: this.selecteds,
        },
        modal: 'selecionarReapresentacaoModal',
        toast: true,
        callback: () => {
          this.abrirFatura(this.fatura, true);
        }
      });

    },

    reapresentar() {
      $('[data-toggle="tooltip"]').tooltip("dispose");
      
      if (!this.selecteds || !this.selecteds.length) {
        alert("Selecione as guias desejadas");
        return;
      }
      
      if (!confirm("Confirma criar uma reapresentação de glosa?")) return;

      if ( this.fatura.fl_reapresentacao ) { 

        this.$util.atualizar(this, {
          service: "faturas",
          func: "reapresentar_reap",
          dados: {
            fatura: {
              id_fatura: this.fatura.id_fatura,
              id_fatura_original: this.fatura.id_fatura_original,
              id_operadora: this.fatura.id_operadora,
            },
            irs: this.selecteds.map(item => {
              return {
                id_item_reapresentacao: item.id_item_reapresentacao,
              };
            })

          },
          callback: () => {
            this.abrirFatura(this.fatura, true);
          }
        });

      } else { 

        this.$util.atualizar(this, {
          service: "faturas",
          func: "reapresentar",
          dados: {
            fatura: {
              id_fatura: this.fatura.id_fatura,
              id_fatura_original: this.fatura.id_fatura_original,
              id_operadora: this.fatura.id_operadora,
            },
            guias: this.selecteds.map(item => {
              return {
                id_guia: item.id_guia,
                dt_criacao: item.dt_criacao
              };
            })

          },
          callback: () => {
            this.abrirFatura(this.fatura, true);
          }
        });

      }
    },

    //

    abrirAtendimento(id_atendimento) { 
      $('.modal').modal('hide');

      this.$nextTick(() => { 
        this.$util.abrir_atendimento(this, id_atendimento);
      });
    },

    abrirFatura(fatura, refresh = false, editarNF = false) {
      this.search = "";
      this.exibir = true;
      this.id_contrato_operadora_selec = null; 

      if ( !refresh )
        this.viewMode = "guias";

      this.$store.commit("loading", true);

      let query = {
        q: [
          {
            name: "configuracoes.check",
            id: "integracao_siad",
            parms:  {
              st_slug: "integracao-siad",
              st_valor: "1",
            }
          },
          {
            name: "configuracoes.check",
            id: "integracao_promedsys",
            parms:  {
              st_slug: "integracao-promedsys",
              st_valor: "1",
            }
          },
          {
            name: "configuracoes.check",
            id: "impressao_laudos",
            parms:  {
              st_slug: "impressao-laudos-faturamento",
              st_valor: "1",
            }
          },
          {
            name: "faturas.show",
            id: "fatura",
            parms: {
              id: fatura.id_fatura,
              fatura: true, 
              novo: true, 
              /*
              with: [
                'guiaFatura.guia.contratoOperadora.unidadeReembolsoNf.logo.arquivo',
                'guiaFatura.guia.contratoOperadora.endereco',
                'guiaFatura.guia.contratoOperadora.endereco.cidade',
                'guiaFatura.guia.atendimento.unidade_operacao:st_nome,st_sigla,fl_nota_fiscal,fl_nota_fiscal_eletronica',
                'guiaFatura.guia.atendimento.unidade_operacao.logo.arquivo',
                'guiaFatura.guia.atendimento.marcacao:id_marcacao,id_atendimento,id_unidade_operacao', 
                'guiaFatura.guia.atendimento.marcacao.unidade_operacao:id_unidade_operacao,st_nome,st_sigla,fl_nota_fiscal,fl_nota_fiscal_eletronica', 
                'guiaFatura.guia.atendimento.marcacao.unidade_operacao.logo.arquivo',
                "operadora.empresa.endereco",
                "operadora.parametroFatura",
                "operadora.categoria",
                "retencoes.imposto", 
                "total_procedimento",
                "total_consumos",
                "total_mov",
                "total_reapresentado",
                "notaFiscalLinks.notaFiscalServico",
                "notaFiscalLink.notaFiscalServico",
              ]
              */
            }
          }
        ]
      }

      this.axios.post('/aql?s=faturas.show', query)
        .then(res => {
          
          if(res.data.integracao_siad.status == 200) {
            this.integracao_siad = res.data.integracao_siad.data
          }

          if(res.data.integracao_promedsys.status == 200) {
            this.integracao_promedsys = res.data.integracao_promedsys.data
          }

          if(res.data.impressao_laudos.status == 200) {
            this.impressao_laudos = res.data.impressao_laudos.data
          }

          if(res.data.fatura.status == 200) {
            this.fatura = res.data.fatura.data;
            this.exibir = true;
            this.exibir_protocolo = this.fatura.exibir_protocolos;

            this.integracao_ipe = _.get(this.fatura, 'operadora.empresa.st_cnpj') == '30483455000176'; // CNPG APEGS
            
            //console.log("###########");
            //console.log(this.fatura);
          }

          if (editarNF) {
            this.$nextTick(() => {
                this.editar_nota_fiscal();
            });    
          }

        })
        .finally(() => {
          this.$store.commit('loading', false);
        })

    },

    editar_guia(guia) {
      this.$refs.edicaoFat.abrir(guia);
    },

    cancelar_fatura() {
      this.envio = null;
      this.cancelar = { st_motivo: "" };
      this.validate = false;

      $("#cancelarModal").modal("show");
    },

    enviar_cancelamento() {
      this.$util.atualizar(this, {
        service: "faturas",
        func: "cancelar",
        modal: "cancelarModal",
        dados: {
          id: this.fatura.id_fatura,
          st_motivo: this.cancelar.st_motivo
        },
        callback: () => {
          this.abrirFatura(this.fatura, true);
        }
      });
    },

    cancelar_mov() {
      if (!confirm("Confirma cancelar a movimentação das guias selecionadas?"))
        return;

      $('[data-toggle="tooltip"]').tooltip("dispose");

      this.dispatch_titulo = "Cancelando movimentações das guias...";

      this.$refs.dispatchModal.executar_chunck(
        "faturas",
        "cancelar_mov",
        this.selecteds,
        'guias',
        {
            reapresentacao: this.fatura.fl_reapresentacao,
        },
        50
      );

    //   this.$util.atualizar(this, {
    //     service: "faturas",
    //     func: "cancelar_mov",
    //     dados: {
    //       guias: this.selecteds,
    //       reapresentacao: this.fatura.fl_reapresentacao,
    //     },
    //     callback: () => {
    //       this.$nextTick(() => {
    //         this.abrirFatura(this.fatura, true);
    //       });
    //     }
    //   });
    },

    marcar_como_enviada() {
      this.validate = false;
      this.cancelar = null;

      this.$util.load(this, { 
        service: 'faturas', 
        func: 'preparar_envio',
        parms: { 
          id_fatura: this.fatura.id_fatura,
        },
        loadTo: res => { 
          this.envio = {
            id: this.fatura.id_fatura,
            dt_emissao: this.fatura.dt_emissao.substr(0, 10),
            dt_envio: null,
            st_protocolo_entrega: null, 
            retencoes: res.retencoes, 
            impostos: res.impostos, 
            dc_valor: res.valor_total, 
          };

          $("#envioModal").modal("show");
        }
      });
    },

    aguardando_protocolo(aguardando = true) {
      this.$util.atualizar(this, {
        service: "faturas",
        func: "aguardando",
        dados: {
          ...this.fatura,
          aguardando: aguardando
        },
        callback: () => {
          this.abrirFatura(this.fatura, true);
        }
      });
    },

    enviar() {
      this.$util.atualizar(this, {
        service: "faturas",
        func: "enviar",
        modal: "envioModal",
        dados: {
          ...this.envio
        },
        callback: () => {
            this.abrirFatura(this.fatura, true);

            const operadoraNF = _.get(this.fatura, 'operadora.fl_nota_fiscal');
            if(this.podeEmietirNotaFiscal && operadoraNF) {
                this.$refs.notaFiscalGeracaoRef.emitirNotaFiscalFatura(this.fatura);
            }
        }
      });
    },

    cancelar_envio() {
      if (!confirm("Cancelar envio?")) return;

      this.$util.atualizar(this, {
        service: "faturas",
        func: "cancelar_envio",
        dados: {
          id: this.fatura.id_fatura
        },
        callback: () => {
          this.abrirFatura(this.fatura, true);
        }
      });
    },

    gerar_arquivo_fatura() {

        if(this.integracao_ipe) {
            this.gerar_arquivo(null, null, null, 'X');
            return;
        }

        let tipoG = null;
        if(this.possuiGuiaTipo('S') && !this.possuiMaisDe100('S')) {
            tipoG = 'S';
        } else if(this.possuiGuiaTipo('C') && !this.possuiMaisDe100('C')) {
            tipoG = 'C';
        } else if(this.possuiGuiaTipo('H') && !this.possuiMaisDe100('H')) {
            tipoG = 'H';
        } else if(this.possuiGuiaTipo('R') && !this.possuiMaisDe100('R')) {
            tipoG = 'R';
        } else if(this.possuiGuiaTipo('D') && !this.possuiMaisDe100('D')) {
            tipoG = 'D';
        }

       this.arq_fatura = null;
       this.arq_fatura = {
            reapresentacao: "R",
            recurso_tipo: 'I',
            guia: {
                sadt: true,
                consulta: true,
                honorario: true,
                internacao: true,
                odonto: true,
            },
            tipo_guia: tipoG,
            tipo_arquivo: "Z",
            ordem: "P",
        };

        this.modal_gerar_arquivo = true; 

        this.$nextTick(() => {
            $("#gerarArquivoModal").modal("show");
        });
        
    },

    atualizar_arquivo_fatura() {
        if(this.arq_fatura.tipo_arquivo == 'X' && this.arq_fatura.tipo_guia == null) {
            this.$toast.add({
              severity: "error",
              summary: "Atenção",
              detail: "Selecione o tipo de guia para gerar o XML",
              life: 3000
            });
            return;
        }

        $("#gerarArquivoModal").modal("hide");
        if(this.fatura){
            if(this.fatura.fl_reapresentacao) {
                if(this.arq_fatura.reapresentacao == "R") {
                    this.gerar_arquivo();
                } else {
                    this.gerar_arquivo(null, 'recurso');
                }
            } else {
                if(this.arq_fatura.tipo_arquivo == "Z") {
                    let tguias = [];
                    if(this.arq_fatura.guia.sadt) {
                       tguias.push('S');
                    }
                    if(this.arq_fatura.guia.consulta) {
                        tguias.push('C');
                    }
                    if(this.arq_fatura.guia.honorario) {
                        tguias.push('H');
                    }
                    if(this.arq_fatura.guia.internacao) {
                        tguias.push('R');
                    }
                    if(this.arq_fatura.guia.odonto) {
                        tguias.push('O');
                    }
                    
                    this.gerar_arquivo(
                        null,
                        null,
                        this.arq_fatura.ordem != "P" ? "S": null,
                        null,
                        tguias
                    );
                } else {
                    this.gerar_arquivo(
                        null,
                        null,
                        this.arq_fatura.ordem != "P" ? "S": null,
                        'S',
                        [this.arq_fatura.tipo_guia]
                    );
                }
            }
        }
    },

    gerar_arquivo(tipo = null, recurso = null, ordenarPorNumero = null, xml = null, tipos_guias = null) {
      this.$store.commit("loading", true);

      let dados = {
        idFatura: this.fatura.id_fatura,
        tipo: tipo,
      };

      if (recurso != null) {
        dados = {...dados, recurso_glosa: 'S', recurso_tipo: this.arq_fatura.recurso_tipo };
      }

      if(ordenarPorNumero != null) {
        dados = {...dados, ordenar_numero: 'S'};
      }

      if(xml != null) {
        dados = {...dados, xml: 'S'};
      }

      if(tipos_guias != null) {
        dados = {...dados, tipos_guias};
      }

      if(this.arq_fatura && this.arq_fatura.selecionadas) {
        dados = {...dados, guias_selecionadas: this.lista.filter(item => item.guia.selected).map(item => item.guia.id_guia)};

        if(dados.guias_selecionadas.length <= 0) {
            this.$toast.add({
              severity: "error",
              summary: "Atenção",
              detail: "Selecione pelo menos uma guia para gerar o arquivo",
              life: 3000
            });

            this.$store.commit("loading", false);
            return;
        }

      }

      const base = this.axios.defaults.baseURL;
      const redir = ( base.substr(0,5) == 'https' )
          ? 'https://api-relatorio.klingo.app/api' 
          : '';

      const jobId = this.uuidv4();
      dados = {...dados, evento: jobId};

      this.dispatch_titulo = "Gerando arquivo...";
      this.$refs.dispatchModal.executar_axios(
        redir + "/fatura_arquivo", 
        dados,
        jobId
      );      

    },
    
    refresh_arquivo_fatura(res) {
        if(res && res.data && res.data.status_code == 403) {
            this.$toast.add({
                severity: "error",
                summary: "Atenção",
                detail: res.data.msg ? res.data.msg : "Erro ao gerar arquivo",
                life: 3000
            });
        } else {
            this.download_arquivo(res.data.key);
        }
    },
    
    download_arquivo(key) {
      this.$store.commit("loading", true);

      let dados = {
        idFatura: this.fatura.id_fatura,
        key: key,
      };

      const base = this.axios.defaults.baseURL;
      const redir = ( base.substr(0,5) == 'https' )
          ? 'https://api-relatorio.klingo.app/api' 
          : '';

      this.axios
        .post(redir + "/fatura_arquivo", dados)
        .then(res => {
          var dataStr =
            "data:text/plain;charset=utf-8," +
            encodeURIComponent(res.data.conteudo);
          var downloadAnchorNode = document.createElement("a");

          if (res.data && res.data.logs && res.data.logs.length ) {
            this.log_exportacao = res.data.logs;
            $('#logExportacaoModal').modal('show');
          } else if (res.data && res.data.conteudo) {
            dataStr =
              "data:text/plain;charset=utf-8," +
              encodeURIComponent(res.data.conteudo);
            downloadAnchorNode.setAttribute("href", dataStr);
            downloadAnchorNode.setAttribute("download", res.data.arquivo);
            document.body.appendChild(downloadAnchorNode);
            downloadAnchorNode.click();
            downloadAnchorNode.remove();
          } else if(res.data && res.data.xml) {
            // Download do XML
            dataStr =
              "data:application/xml;charset=utf-8," +
                encodeURIComponent(res.data.xml);
            downloadAnchorNode = document.createElement("a");
            downloadAnchorNode.setAttribute("href", dataStr);
            downloadAnchorNode.setAttribute("download", res.data.arquivo);
            document.body.appendChild(downloadAnchorNode);
            downloadAnchorNode.click();
            downloadAnchorNode.remove();
          } else {
            // Download arquivo ZIP
            window.open(res.data, '_blank');
          }
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });

    },
    
    uuidv4() {
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },

    abrir(guias) {
      this.guias = guias;
      $("#criarFaturaModal").modal("show");
    },

    criar() {
      this.$util.atualizar(this, {
        service: "guias",
        func: "faturar",
        dados: {
          qtd: this.guias.length,
          id_operadora: this.guias.length
            ? this.guias[0].plano.id_operadora
            : -1,
          guias: this.guias.map(item => {
            return {
              id_guia: item.id_guia,
              ch_status: item.ch_status,
              dt_criacao: item.dt_criacao
            };
          })
        },
        callback: res => {
          this.$emit("refresh");
          $("#criarFaturaModal").modal("hide");
          this.fatura = res;
          $("#faturaModal").modal("show");
        }
      });
    },
    getNFStatusClass: function(fatura) {
        if(!fatura.nota_fiscal_link || !fatura.nota_fiscal_link.nota_fiscal_servico) return 'info';

        const status = fatura.nota_fiscal_link.nota_fiscal_servico.ch_status;

        switch (status) {
            case "1":
                return "info";
            case "2":
                return "primary";
            case "3":
                return "warning";
            case "4":
                return "success";
            case "5":
                return "danger";

            default:
                return "success";
        }
    },

    integrar_com_siad(fatura, selecionar = false) {

      this.lista_guias_siad = null;

      let dados = {
          id_fatura: fatura.id_fatura,
        };

      if(selecionar) {

          if(!this.selecteds || this.selecteds.length == 0) {
            
            this.$toast.add({
              severity: "error",
              summary: "Atenção",
              detail: "Nenhuma guia selecionada",
              life: 5000
            })

            return;
 
          }

          dados.idGuias = this.selecteds.map(item => {
            return item.id_guia;
          })

      }

      $('#integrarSiadModal').modal('show');

      this.$util.load(this, { 
        service: 'integrador_siad',
        func: 'siad_guias_arquivos',
        parms: { 
          id_fatura: dados.id_fatura, 
          guias: dados.idGuias, 
        },
        loadTo: res => { 
          this.lista_guias_siad = res;
        }
      });
      
    },

    exportar_siad () { 
      this.$util.atualizar(this,
        {
          service: "integrador_siad",
          func: "enviar_fatura",
          toast: true,
          dados: { 
            id_fatura: this.fatura.id_fatura,
            guias: this.lista_guias_siad.map(item => item.id_guia),
          },
          modal: "integrarSiadModal",
          callback: (res) => {
            console.log(res);
            if(res && res.id_batch) {
                this.fatura.st_siad_batch_id = res.id_batch;
            }
          }
        }
      )
    },

    pegar_nome_capa() {

      if ( this.fatura && this.fatura.guia_fatura && this.fatura.guia_fatura.guia && this.fatura.guia_fatura.guia.contrato_operadora ) { 
      
        const contratoOperadora = this.fatura.guia_fatura.guia.contrato_operadora;

        if(contratoOperadora) {

          if(contratoOperadora.ch_tipo_codigo_operadora == 2 && contratoOperadora.st_numero_prestador) {
              if(contratoOperadora.st_descricao_arquivo_contrato) {
                return contratoOperadora.st_descricao_arquivo_contrato;
              }
          }

        }

      }
      
      return this.fatura.operadora.search 
    },

    pegar_cnpj_capa () {

      if ( this.fatura && this.fatura.guia_fatura && this.fatura.guia_fatura.guia && this.fatura.guia_fatura.guia.contrato_operadora ) { 
      
        const contratoOperadora = this.fatura.guia_fatura.guia.contrato_operadora;

        if(contratoOperadora) {
          console.log(contratoOperadora)
          if(contratoOperadora.ch_tipo_codigo_operadora == 2 && contratoOperadora.st_numero_prestador) { 
            return this.$util.formatMask(contratoOperadora.st_numero_prestador, "cnpj")
          }

        }
        
      }
      
      return this.$util.formatMask(this.fatura.operadora.empresa.st_cnpj, "cnpj");
    },

    pegar_endereco_capa() {

      const enderecoContrato = _.get(this, 'fatura.guia_fatura.guia.contrato_operadora.endereco');

      let endereco = '';

      if(enderecoContrato) {

        endereco = enderecoContrato.st_logradouro +
              ', ' +
              enderecoContrato.st_numero +
              ' - Bairro: ' +
              enderecoContrato.st_bairro +
              ' - CEP: ' +
              this.$util.formatMask(enderecoContrato.in_cep, 'cep');

        if(enderecoContrato.cidade) {
          endereco += ' - ' + enderecoContrato.cidade.st_cidade;
        }

        return endereco;
      }

      endereco = this.fatura.operadora.empresa.endereco.st_logradouro +
          ', ' +
          this.fatura.operadora.empresa.endereco.st_numero +
          ' - Bairro: ' +
          this.fatura.operadora.empresa.endereco.st_bairro +
          ' - CEP: ' +
          this.$util.formatMask(
              this.fatura.operadora.empresa.endereco.in_cep,
              "cep");

          if(this.fatura.operadora.empresa.endereco.cidade) {
            + ' - ' +
            this.fatura.operadora.empresa.endereco.cidade.st_cidade;
          }

          return endereco;
    }
    
  },

  updated() {
    $('[data-toggle="tooltip"]').tooltip();
  }
};
</script>
